// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T20:58:25.165Z
// Property: Chambers Creek Estates (ID: 6767906449166879)
// Collections: 26 amenities, 5 floorplans (live), 22 photos, 43 POIs, 2 reviews, 3 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166879",
  "property_external_id": "495792",
  "property_zillow_url": "https://www.zillow.com/homedetails/Chambers-Creek-Rd-W-University-Place-WA-98467/102605291_zpid/",
  "property_apartments_url": "https://www.apartments.com/parks-and-recreation/wa/tacoma/chambers-creek-regional-park/82bs6k3/2/",
  "property_google_business_url": "https://www.google.com/maps/place/Chambers+Creek+Estates/data=!4m2!3m1!1s0x0:0x5b3e1f29dd38e41?sa=X&ved=2ahUKEwi0zJT9_ruSAxWFUFUIHa3LDBEQ_BJ6BAgUEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "51934474406",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495792 p0505460",
  "property_status": null,
  "property_slug": "chambers-creek-estates",
  "property_name": "Chambers Creek Estates",
  "property_website_url": "www.universityplace-apartments.com",
  "property_domain": "https://www.universityplace-apartments.com/",
  "property_address": "6124 70th Avenue Court West",
  "property_full_address": "6124 70th Avenue Court West, University Place, WA, 98467",
  "property_address_1": "6124 70th Avenue Court West",
  "property_address_2": null,
  "property_address_city": "University Place",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98467",
  "property_address_country": "US",
  "property_address_county": "Pierce County",
  "property_neighborhood_address": null,
  "property_address_latitude": "47.2007086",
  "property_address_longitude": "-122.531138",
  "property_email": "chamberscreek@ctlmanagement.com",
  "property_phone": "(253) 528-5419",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Chambers Creek Estates in University Place, WA, where spacious living meets vibrant amenities. Choose from cozy studios to expansive three-bedroom layouts. Enjoy our outdoor basketball courts, inviting clubhouse, and relaxing indoor pool. Elevate your lifestyle today—check availability or schedule a tour to see your future home!",
  "property_long_description": "The quest for the perfect home stops at Chambers Creek Estates. Brimming with attractive amenities, cozy interiors, and relaxing leisure areas, our apartments in University Place offer comfort and convenience in a desirable location.An exciting new chapter begins as soon as you take your pick from our studio, one, two, and three-bedroom layouts, ranging from 546 to 1,315 square feet. Life's essential amenities and extra comforts are a given from the get-go. Some of these highlights include a washer and dryer, wood-burning fireplaces, as well as a lovely patio or balcony. You will be just as charmed by our state-of-the-art fitness center, indoor and outdoor pools, and BBQ and picnic area, not to mention the indoor and outdoor basketball courts.Keep browsing the website to learn more about our pet-friendly community!Managed by CTL Management, Inc.This community does not accept comprehensive reusable tenant screening reports.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019db13a-b493-713a-b664-6c8a36ff25a9.webp",
  "property_featured_image_media": {
    "alt_text": "Modern seating area with black and white chevron pattern furniture, coffee table, and black leather chairs.",
    "public_id": "019db13a-b493-713a-b664-6c8a36ff25a9",
    "storage_key": "property/6767906449166879/019db13a-b493-713a-b664-6c8a36ff25a9.webp",
    "width": 1920,
    "height": 972
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Deposit: $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Deposit and monthly pet rent are per pet.  Small caged animals are allowed without a deposit and pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Maximum Number of Pets: 2 (Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old)\nMaximum Weight Limit: 25 pounds\nMonthly Pet Rent: $30 per pet\nDeposit: $400 per pet",
  "property_online_leasing_url": "https://universityplace-apartments.securecafe.com/onlineleasing/chambers-creek-estates/floorplans.aspx",
  "property_resident_portal_url": "https://universityplace-apartments.securecafe.com/residentservices/chambers-creek-estates/userlogin.aspx",
  "property_apply_now_url": "https://universityplace-apartments.securecafe.com/onlineleasing/chambers-creek-estates/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019db13b-46d8-75fd-869e-98df1e1cab22.webp",
  "property_primary_logo_media": {
    "alt_text": "Chambers Creek Estates apartments logo",
    "public_id": "019db13b-46d8-75fd-869e-98df1e1cab22",
    "storage_key": "property/6767906449166879/019db13b-46d8-75fd-869e-98df1e1cab22.webp",
    "width": 2410,
    "height": 320
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019db1a2-8e4f-730c-97df-ba7306340431.webp",
  "property_secondary_logo_media": {
    "alt_text": "Chambers Creek Estates Apartments logo",
    "public_id": "019db1a2-8e4f-730c-97df-ba7306340431",
    "storage_key": "property/6767906449166879/019db1a2-8e4f-730c-97df-ba7306340431.webp",
    "width": 1210,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019db14e-ae1d-7057-b664-d1728bb6d147.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Generic dark gray horizontal banner.",
    "public_id": "019db14e-ae1d-7057-b664-d1728bb6d147",
    "storage_key": "property/6767906449166879/019db14e-ae1d-7057-b664-d1728bb6d147.webp",
    "width": 1280,
    "height": 169
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019db14e-a14b-729e-b5dc-5cd764ca92af.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black rectangle with white border",
    "public_id": "019db14e-a14b-729e-b5dc-5cd764ca92af",
    "storage_key": "property/6767906449166879/019db14e-a14b-729e-b5dc-5cd764ca92af.webp",
    "width": 1280,
    "height": 169
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "546 - 1315",
  "property_sqft_min": "546",
  "property_sqft_max": "1315",
  "property_price_range": "1260 - 2140",
  "property_price_min": "1260",
  "property_price_max": "2140",
  "property_available_units": 25,
  "property_facebook_url": "https://www.facebook.com/chamberscreekestatesapartmenthomes/about",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJs4av1n6qkVQRQY7TnfLhswU",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/chambers-creek-estates-university-place-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Chambers Creek Estates",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "At Chambers Creek Estates in University Place, WA, you’ll find spacious studio to three-bedroom apartments paired with incredible amenities. Enjoy outdoor basketball courts, a serene BBQ area, and a relaxing indoor pool. With online conveniences and a vibrant resident program, life here is all about comfort and connection.",
  "property_home_floorplans_blurb": "At Chambers Creek Estates in vibrant University Place, WA, we offer a variety of stylish floor plans to suit every lifestyle. From cozy studios to spacious three-bedroom apartments, your ideal home awaits. Browse our available options and envision the life you’ll create in our welcoming community.",
  "property_home_gallery_blurb": "At Chambers Creek Estates in University Place, WA, spacious living meets exceptional amenities. Choose from studio to three-bedroom floor plans, and enjoy outdoor basketball courts, a cozy coffee bar, and a refreshing indoor pool. Picture yourself thriving in a smoke-free environment tailored for your active lifestyle!",
  "property_home_neighborhood_blurb": "At Chambers Creek Estates in University Place, WA, experience a lifestyle enriched by nature and culture. Nestled near the scenic Chambers Creek Regional Park and renowned local attractions like the Museum of Glass and Tacoma Art Museum, our community offers varied floor plans to fit your needs. See what's around and uncover local favorites!",
  "property_home_reviews_blurb": "Welcome to Chambers Creek Estates, where lush grounds meet a vibrant community in University Place, WA. Residents rave about our resort-style amenities and unparalleled safety. One resident shares, “This place is like a resort,” highlighting the exceptional care from our management team. Experience the charm and comfort our residents cherish!",
  "property_neighborhood_blurb": "Nestled in University Place, Chambers Creek Estates offers more than just stylish living—it's your gateway to adventure. Immerse yourself in nature at Chambers Creek Regional Park, explore art at the Tacoma Art Museum, or enjoy family fun at Point Defiance Zoo & Aquarium. Experience vibrant community life right outside your door!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Chambers Creek Estates in University Place, WA, our diverse floor plans—from cozy studios to spacious three-bedrooms—accommodate every lifestyle. Enjoy an array of amenities like indoor swimming, outdoor basketball courts, and a vibrant clubhouse, all within a smoke-free environment that prioritizes your comfort and convenience. Join our community today!",
  "property_applynow_blurb": "At Chambers Creek Estates in University Place, WA, choose from spacious studio, one, two, or three-bedroom floor plans crafted for comfort and style. Enjoy amenities like a heated indoor pool, outdoor basketball courts, and a cozy coffee bar. Your new home is just a click away—apply online today!",
  "property_contactus_blurb": "At Chambers Creek Estates in University Place, WA, we offer a range of thoughtfully designed floor plans, from cozy studios to spacious three-bedroom apartments. Each unique layout caters to your lifestyle needs. Have questions? Contact our leasing team today to find the perfect home just for you!",
  "property_faqs_blurb": "At Chambers Creek Estates in University Place, WA, our diverse floor plans—ranging from cozy studios to spacious three-bedroom apartments—offer something for everyone. Have questions? Uncover the answers about our vibrant community by visiting our FAQs page today. Your ideal living experience awaits!",
  "property_floorplans_blurb": "At Chambers Creek Estates in University Place, WA, choose from an array of thoughtfully designed floor plans, including cozy studios and spacious three-bedroom apartments. Each layout offers modern living with unique touches. Browse our available apartment homes to find the perfect fit for your lifestyle and make it your own!",
  "property_gallery_blurb": "At Chambers Creek Estates in University Place, WA, everyday life meets exceptional living. Choose from spacious studio to three-bedroom floor plans, perfect for any lifestyle. Enjoy amenities like indoor swimming, outdoor basketball courts, and a cozy coffee bar. Picture yourself living here—your ideal retreat awaits in our vibrant community!",
  "property_interactivemap_blurb": "Welcome to Chambers Creek Estates in University Place, WA, where spacious living meets unmatched convenience. Choose from studio to three-bedroom layouts, enjoy modern amenities like an indoor pool, outdoor basketball courts, and a cozy coffee bar. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Chambers Creek Estates in University Place, WA, your furry family members will feel right at home. Enjoy a vibrant community that welcomes indoor adult cats and dogs, offering ample space and comfort. With our flexible pet policy, bring your beloved companions along for the adventure!",
  "property_referafriend_blurb": "At Chambers Creek Estates in University Place, WA, we celebrate the spirit of community! From cozy studios to spacious three-bedroom layouts, your ideal home awaits. Invite a friend to share in the joy of vibrant living—because great friends make great neighbors. Refer a friend today and enhance our thriving community!",
  "property_residentaccess_blurb": "At Chambers Creek Estates in University Place, WA, your comfort is our priority. With versatile floor plans—from cozy studios to spacious three-bedrooms—tailor your living experience to fit your lifestyle. Access your resident portal for easy rent payments, maintenance requests, and a sense of community just a click away!",
  "property_reviews_blurb": "At Chambers Creek Estates in University Place, WA, residents rave about our “beautifully maintained grounds” and the welcoming, resort-like atmosphere. With a focus on safety and resident concerns, it's no wonder our community receives top ratings. Join us and experience the exceptional quality of life we offer!",
  "property_created_at": "1762784590989",
  "property_scheduletour_blurb": "At Chambers Creek Estates in University Place, WA, we offer a diverse range of floor plans—studio, one, two, and three-bedroom options—to suit your lifestyle. Ready to find your perfect fit? Schedule a tour today and see what our residents love about their vibrant community!",
  "property_thankyou_blurb": "Thank you for reaching out to Chambers Creek Estates in University Place, WA! Your perfect home awaits, whether you’re looking for a cozy studio or a spacious three-bedroom apartment. Our diverse floor plans cater to every lifestyle. A team member will be in touch soon to assist you further!",
  "property_virtualtours_blurb": "At Chambers Creek Estates in University Place, WA, spacious living meets modern convenience. Choose from thoughtfully designed studio, one, two, or three-bedroom floor plans tailored to your lifestyle. Experience the ambiance and vibrant community spirit—take a virtual tour today and envision your new home!",
  "property_copyright": "2025 All Rights Reserved. Chambers Creek Estates",
  "property_seo_title_home": "Chambers Creek Estates |  Apartments in University Place, WA",
  "property_seo_description_home": "Welcome to Chambers Creek Estates in University Place, WA—offering spacious floor plans, top-notch amenities, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | University Place, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Chambers Creek Estates, University Place. Choose from stylish studio to spacious three-bedroom layouts. Browse our floor plans today!",
  "property_seo_title_amenities": "Amenities | University Place, WA Apartments for Rent",
  "property_seo_description_amenities": "Experience the vibrant lifestyle at Chambers Creek Estates in University Place, WA. From spacious floor plans to premier amenities, your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in University Place, WA",
  "property_seo_description_gallery": "Discover your ideal lifestyle at Chambers Creek Estates! Enjoy spacious floor plans, premium amenities, and vibrant living in University Place, WA.",
  "property_seo_title_virtualtours": "Virtual Tours | Chambers Creek Estates Apartments",
  "property_seo_description_virtualtours": "Step into Chambers Creek Estates in University Place, WA. Immerse yourself in our unique virtual tour of stylish studios to spacious three-bedroom apartments!",
  "property_seo_title_interactivemap": "Interactive Map | Chambers Creek Estates Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Chambers Creek Estates in University Place, WA! View spacious floor plans and enjoy top-tier amenities, all with our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in University Place, WA",
  "property_seo_description_neighborhood": "Uncover the vibrant life around Chambers Creek Estates in University Place, WA. Discover local favorites and hidden gems just steps from your doorstep!",
  "property_seo_title_contact": "Contact Us | Chambers Creek Estates",
  "property_seo_description_contact": "Contact Chambers Creek Estates in University Place, WA. Our leasing team is ready to help with inquiries about our floor plans—let's connect!",
  "property_seo_title_faqs": "FAQs | Apartments in University Place, WA",
  "property_seo_description_faqs": "Find quick answers to your questions about Chambers Creek Estates in University Place, WA. Uncover our spacious floor plans, amenities, and more!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in University Place, WA",
  "property_seo_description_reviews": "Discover life at Chambers Creek Estates in University Place, WA. See resident reviews and find out why our spacious homes and amenities shine!",
  "property_seo_title_applynow": "Apply Now | Apartments in University Place, WA",
  "property_seo_description_applynow": "Find your perfect home at Chambers Creek Estates in University Place! Spacious floor plans, smoke-free living, and top-notch amenities await. Apply online!",
  "property_seo_title_residentaccess": "Resident Access | Chambers Creek Estates",
  "property_seo_description_residentaccess": "Log in to your Chambers Creek Estates portal to pay rent, request maintenance, and enjoy community living in University Place, WA!",
  "property_seo_title_referafriend": "Refer A Friend | Chambers Creek Estates",
  "property_seo_description_referafriend": "Refer a friend to Chambers Creek Estates in University Place, WA! Great friends make great neighbors—share the joy of community living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Chambers Creek Estates",
  "property_seo_description_scheduletour": "Experience vibrant living at Chambers Creek Estates! Schedule a tour today and see why our University Place community is the perfect place to call home.",
  "property_seo_title_privacy": "Privacy Policy | Chambers Creek Estates",
  "property_seo_description_privacy": "Protecting your privacy is our priority at Chambers Creek Estates. Learn how we safeguard your information in our comprehensive privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Chambers Creek Estates",
  "property_seo_description_accessibility": "At Chambers Creek Estates, we prioritize digital inclusion, ensuring accessibility for all. Experience a community where everyone is welcome and connected.",
  "property_seo_title_sitemap": "Sitemap | Chambers Creek Estates",
  "property_seo_description_sitemap": "Uncover the layout of Chambers Creek Estates in University Place, WA. Navigate our community amenities and find your perfect home. Access our sitemap today!",
  "property_seo_title_thankyou": "Thank You | Chambers Creek Estates",
  "property_seo_description_thankyou": "Thank you for reaching out! Our team at Chambers Creek Estates will connect soon to help you find your perfect home in University Place, WA! Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in University Place, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778874660124",
  "amenities": [
    {
      "id": "ec_010e22f07e47e1584f051b07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80428706",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-6495-751a-8b7a-2f8cfe6ec1de.webp",
      "amenity_image_media": {
        "alt_text": "Gym with weight machines and cardio equipment",
        "public_id": "019d08a9-6495-751a-8b7a-2f8cfe6ec1de",
        "storage_key": "property/6767906449166879/019d08a9-6495-751a-8b7a-2f8cfe6ec1de.webp",
        "width": 972,
        "height": 683
      },
      "amenity_image_alt_text": "Fitness Center & Equipment at Chambers Creek Estates, University Place, 98467",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_415aa5bbefad746542590f26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80428712",
      "title": "Sauna",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-6e3e-70f5-b36e-ed2eff4d1e27.webp",
      "amenity_image_media": {
        "alt_text": "Wooden sauna with benches and a heater.",
        "public_id": "019d08a9-6e3e-70f5-b36e-ed2eff4d1e27",
        "storage_key": "property/6767906449166879/019d08a9-6e3e-70f5-b36e-ed2eff4d1e27.webp",
        "width": 1007,
        "height": 656
      },
      "amenity_image_alt_text": "Sauna at Chambers Creek Estates, WA 98467",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_47603a8ef0a88f2880b071e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80428708",
      "title": "Indoor Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-5f14-74ee-b40e-c4b08d542d48.webp",
      "amenity_image_media": {
        "alt_text": "Basketball court with wood-paneled walls and red padding.",
        "public_id": "019d08a9-5f14-74ee-b40e-c4b08d542d48",
        "storage_key": "property/6767906449166879/019d08a9-5f14-74ee-b40e-c4b08d542d48.webp",
        "width": 1029,
        "height": 647
      },
      "amenity_image_alt_text": "Basketball Court at Chambers Creek Estates, WA 98467",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6c786cc1317650aa8e55be4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80428709",
      "title": "Outdoor Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-758b-733c-abc7-c6085c10a4bc.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a table with an umbrella.",
        "public_id": "019d08a9-758b-733c-abc7-c6085c10a4bc",
        "storage_key": "property/6767906449166879/019d08a9-758b-733c-abc7-c6085c10a4bc.webp",
        "width": 1014,
        "height": 661
      },
      "amenity_image_alt_text": "Outdoor Pool at Chambers Creek Estates, University Place",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c1daca75c2b4a167f9d1483",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80428710",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-87f9-74d7-8c5d-db69bd7c4aad.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slides and swings adjacent to apartment buildings.",
        "public_id": "019d08a9-87f9-74d7-8c5d-db69bd7c4aad",
        "storage_key": "property/6767906449166879/019d08a9-87f9-74d7-8c5d-db69bd7c4aad.webp",
        "width": 1029,
        "height": 683
      },
      "amenity_image_alt_text": "Playground at Chambers Creek Estates, University Place, Washington 98467",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17f69662307276f4d4c905e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "86392963",
      "title": "Clubhouse with Complimentary Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-54f5-771a-b7de-f828a5df8c74.webp",
      "amenity_image_media": {
        "alt_text": "Interior lounge area with chevron patterned furniture and a large black and white rug.",
        "public_id": "019d08a9-54f5-771a-b7de-f828a5df8c74",
        "storage_key": "property/6767906449166879/019d08a9-54f5-771a-b7de-f828a5df8c74.webp",
        "width": 1007,
        "height": 676
      },
      "amenity_image_alt_text": "Clubhouse Seating Area at Chambers Creek Estates, Washington, 98467",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_52fa3588f641ea8abd4feaa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80665106",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-6106-75f4-9f96-c972528dff50.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers and printer.",
        "public_id": "019d08a9-6106-75f4-9f96-c972528dff50",
        "storage_key": "property/6767906449166879/019d08a9-6106-75f4-9f96-c972528dff50.webp",
        "width": 1025,
        "height": 680
      },
      "amenity_image_alt_text": "Business Center at Chambers Creek Estates, University Place, WA",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54e0124518f18999db876adf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "86392961",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7909b8f4fd385a99b09f90c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80665107",
      "title": "Indoor Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-7271-70c0-9758-be72f48644af.webp",
      "amenity_image_media": {
        "alt_text": "Indoor swimming pool with wood-paneled walls and ceiling.",
        "public_id": "019d08a9-7271-70c0-9758-be72f48644af",
        "storage_key": "property/6767906449166879/019d08a9-7271-70c0-9758-be72f48644af.webp",
        "width": 640,
        "height": 480
      },
      "amenity_image_alt_text": "Chambers Creek Indoor Pool",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_206f007303ee880ddd442f8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "86391168",
      "title": "2 Outdoor Basketball Courts",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-8e4d-7240-943c-36101406af4c.webp",
      "amenity_image_media": {
        "alt_text": "Basketball court and playground with apartment buildings in the background.",
        "public_id": "019d08a9-8e4d-7240-943c-36101406af4c",
        "storage_key": "property/6767906449166879/019d08a9-8e4d-7240-943c-36101406af4c.webp",
        "width": 1029,
        "height": 683
      },
      "amenity_image_alt_text": "Outdoor Basketball Court Exterior at Chambers Creek Estates, University Place, Washington 98467",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_75bb402398222e21efdf338d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "86392962",
      "title": "Self-Service Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-765b-77aa-ad3b-3444c68236d3.webp",
      "amenity_image_media": {
        "alt_text": "Amazon Hub package locker system with a digital screen and keypad.",
        "public_id": "019d08a9-765b-77aa-ad3b-3444c68236d3",
        "storage_key": "property/6767906449166879/019d08a9-765b-77aa-ad3b-3444c68236d3.webp",
        "width": 2304,
        "height": 3072
      },
      "amenity_image_alt_text": "Self Service Package Lockers   at Chambers Creek Estates, Washington",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_375fef58a934ab1965042eff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80665109",
      "title": "BBQ And Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-8565-711b-8106-cb81a5df8926.webp",
      "amenity_image_media": {
        "alt_text": "Basketball court and picnic area with picnic tables and grills.",
        "public_id": "019d08a9-8565-711b-8106-cb81a5df8926",
        "storage_key": "property/6767906449166879/019d08a9-8565-711b-8106-cb81a5df8926.webp",
        "width": 640,
        "height": 480
      },
      "amenity_image_alt_text": "Chambers Creek Picnic Area",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a6aed1e1b3c25e3280c199e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80665108",
      "title": "Carports For Rent",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_380192d1db8de06a06ba90a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "86392959",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a70c8e9537bc173879c5a6e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "86392960",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_970e96a5b312a9142cca8148",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "81384757",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e8cb53ffdaa9634f5ea1d23e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "82390139",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_faffa50b3438f69b863fcb0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "82390140",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee3fe91ea7a00498f73b4f12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80428713",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4eca49eb2b5c48813dc5af95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80428719",
      "title": "Wood Burning Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-f8f4-7712-a4b5-9d5eee4d4a89.webp",
      "amenity_image_media": {
        "alt_text": "Living room with fireplace, TV, and seating area.",
        "public_id": "019d08a9-f8f4-7712-a4b5-9d5eee4d4a89",
        "storage_key": "property/6767906449166879/019d08a9-f8f4-7712-a4b5-9d5eee4d4a89.webp",
        "width": 640,
        "height": 480
      },
      "amenity_image_alt_text": "Chambers Creek Model Apartment Living Room,Fireplace & Patio Sliding Door at Chambers Creek Estates, WA 98467",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fcbba7c6e1507d8417096110",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80428715",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-3eaf-762f-89b0-cca7850e2364.webp",
      "amenity_image_media": {
        "alt_text": "Balcony with seating area and trees",
        "public_id": "019d08a9-3eaf-762f-89b0-cca7850e2364",
        "storage_key": "property/6767906449166879/019d08a9-3eaf-762f-89b0-cca7850e2364.webp",
        "width": 640,
        "height": 480
      },
      "amenity_image_alt_text": "Chambers Creek Model Apartment Patio",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94645409156efa16688f2cfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80428717",
      "title": "Standard Kitchen Appliances Included",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-43e8-75f6-9360-ff04fb9a2993.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with wooden cabinets, white appliances, and granite countertops.",
        "public_id": "019d08a9-43e8-75f6-9360-ff04fb9a2993",
        "storage_key": "property/6767906449166879/019d08a9-43e8-75f6-9360-ff04fb9a2993.webp",
        "width": 1029,
        "height": 643
      },
      "amenity_image_alt_text": "Kitchen at Chambers Creek Estates, Washington, 98467",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d5dab6b40a0c406be17cc45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80428714",
      "title": "Mt. Rainier And Cascade Range Views - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9b86-721a-8293-e214b9203f20.webp",
      "amenity_image_media": {
        "alt_text": "Snow-capped mountain peak visible through evergreen trees under a blue sky.",
        "public_id": "019d08a9-9b86-721a-8293-e214b9203f20",
        "storage_key": "property/6767906449166879/019d08a9-9b86-721a-8293-e214b9203f20.webp",
        "width": 640,
        "height": 480
      },
      "amenity_image_alt_text": "Chambers Creek Mt. Rainier View",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1ba3de2513973dd68370ed0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80428718",
      "title": "Very Spacious Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_be3683b110bef6efe9aa6b50",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80428716",
      "title": "Smoke Free Housing - See Policy",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_071ce99eaef805480098a819",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "external_id": "80665110",
      "title": "Storage - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_ad2c4c2f7d57bfbaf049f2cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-41cc-7439-b472-26d1be51b7d6.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace and a sliding glass door leading to a playground.",
        "public_id": "019d08a9-41cc-7439-b472-26d1be51b7d6",
        "storage_key": "property/6767906449166879/019d08a9-41cc-7439-b472-26d1be51b7d6.webp",
        "width": 1011,
        "height": 619
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace and a sliding glass door with a view of the community playground. Perfect for family living.",
      "link": "false",
      "alt_text": "Living room with a fireplace and a sliding glass door leading to a playground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_Vacant Living Room.jpg"
    },
    {
      "id": "ec_fb986cb31e8362f41a829aa4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-3eaf-762f-89b0-cca7850e2364.webp",
      "image_media": {
        "alt_text": "Balcony with seating area and trees",
        "public_id": "019d08a9-3eaf-762f-89b0-cca7850e2364",
        "storage_key": "property/6767906449166879/019d08a9-3eaf-762f-89b0-cca7850e2364.webp",
        "width": 640,
        "height": 480
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on this private balcony, offering a tranquil outdoor space with lush green surroundings.",
      "link": "false",
      "alt_text": "Balcony with seating area and trees",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_ModelPatio.jpg"
    },
    {
      "id": "ec_771e087a33865e99d6d55e7f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-43e8-75f6-9360-ff04fb9a2993.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white appliances, and granite countertops.",
        "public_id": "019d08a9-43e8-75f6-9360-ff04fb9a2993",
        "storage_key": "property/6767906449166879/019d08a9-43e8-75f6-9360-ff04fb9a2993.webp",
        "width": 1029,
        "height": 643
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample storage with honey oak cabinets, granite-look countertops, and a breakfast bar. Equipped with a full suite of white appliances including a refrigerator, dishwasher, and stove.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, white appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_VacantUpgradedKitchen01.jpg"
    },
    {
      "id": "ec_50b9bd81f879f35ff844a0ea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-4408-744c-88a2-dd436ad5d593.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white stove, and a pass-through counter to the living room with a fireplace.",
        "public_id": "019d08a9-4408-744c-88a2-dd436ad5d593",
        "storage_key": "property/6767906449166879/019d08a9-4408-744c-88a2-dd436ad5d593.webp",
        "width": 1021,
        "height": 677
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring wood cabinetry, a white stove, and a convenient pass-through counter. The adjacent living room boasts a cozy fireplace and access to a balcony.",
      "link": "false",
      "alt_text": "Kitchen with wood cabinets, white stove, and a pass-through counter to the living room with a fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_VacantUpgradedKitchen02.jpg"
    },
    {
      "id": "ec_244773c3667daf9a4f9cc4a7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-50ea-702e-a200-ed411a96ff1b.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and adjacent kitchen",
        "public_id": "019d08a9-50ea-702e-a200-ed411a96ff1b",
        "storage_key": "property/6767906449166879/019d08a9-50ea-702e-a200-ed411a96ff1b.webp",
        "width": 998,
        "height": 580
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace, seamlessly flowing into a functional kitchen with ample cabinet space and modern appliances.",
      "link": "false",
      "alt_text": "Living room with fireplace and adjacent kitchen",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_VacantUpgradedKitchen03.jpg"
    },
    {
      "id": "ec_4d6188da32b5647dc931829d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-4fdb-760e-afd1-edb1ea4fea89.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-sized bed, red accent wall, and large window.",
        "public_id": "019d08a9-4fdb-760e-afd1-edb1ea4fea89",
        "storage_key": "property/6767906449166879/019d08a9-4fdb-760e-afd1-edb1ea4fea89.webp",
        "width": 640,
        "height": 480
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-sized bed and a vibrant red accent wall for a warm and inviting atmosphere.",
      "link": "false",
      "alt_text": "Cozy bedroom with a king-sized bed, red accent wall, and large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_Model Master Bedroom.jpg"
    },
    {
      "id": "ec_ad48607ed74b3c3414e608fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-5289-728c-9847-202e1c0851a4.webp",
      "image_media": {
        "alt_text": "Children's bedroom with an ocean theme, featuring a bed with shark and fish decorations.",
        "public_id": "019d08a9-5289-728c-9847-202e1c0851a4",
        "storage_key": "property/6767906449166879/019d08a9-5289-728c-9847-202e1c0851a4.webp",
        "width": 640,
        "height": 480
      },
      "title": "Apartment",
      "description": "Immerse yourself in an underwater fantasy in this charming bedroom, perfect for young adventurers. Features ocean-themed decor, a comfortable bed, and playful accents.",
      "link": "false",
      "alt_text": "Children's bedroom with an ocean theme, featuring a bed with shark and fish decorations.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_ModelSecondBedroom.jpg"
    },
    {
      "id": "ec_1a1b5f7402df433121a929e9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-54f5-771a-b7de-f828a5df8c74.webp",
      "image_media": {
        "alt_text": "Interior lounge area with chevron patterned furniture and a large black and white rug.",
        "public_id": "019d08a9-54f5-771a-b7de-f828a5df8c74",
        "storage_key": "property/6767906449166879/019d08a9-54f5-771a-b7de-f828a5df8c74.webp",
        "width": 1007,
        "height": 676
      },
      "title": "Community",
      "description": "Relax and unwind in the stylish lounge area, featuring comfortable seating and modern decor.",
      "link": "false",
      "alt_text": "Interior lounge area with chevron patterned furniture and a large black and white rug.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_Clubhouse01.jpg"
    },
    {
      "id": "ec_b3b2b25a1b21d0803e19b08e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-6106-75f4-9f96-c972528dff50.webp",
      "image_media": {
        "alt_text": "Business center with computers and printer.",
        "public_id": "019d08a9-6106-75f4-9f96-c972528dff50",
        "storage_key": "property/6767906449166879/019d08a9-6106-75f4-9f96-c972528dff50.webp",
        "width": 1025,
        "height": 680
      },
      "title": "Community",
      "description": "Utilize the convenient business center, equipped with computers and a printer, for all your professional needs.",
      "link": "false",
      "alt_text": "Business center with computers and printer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_Business Center.jpg"
    },
    {
      "id": "ec_7299aa3001ae6cb98a1eeb4c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-5f14-74ee-b40e-c4b08d542d48.webp",
      "image_media": {
        "alt_text": "Basketball court with wood-paneled walls and red padding.",
        "public_id": "019d08a9-5f14-74ee-b40e-c4b08d542d48",
        "storage_key": "property/6767906449166879/019d08a9-5f14-74ee-b40e-c4b08d542d48.webp",
        "width": 1029,
        "height": 647
      },
      "title": "Community",
      "description": "Shoot some hoops on our indoor basketball court, a perfect place to stay active and have fun.",
      "link": "false",
      "alt_text": "Basketball court with wood-paneled walls and red padding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_BasketballCourt.jpg"
    },
    {
      "id": "ec_676a1871c9a34df15aad6bbd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-6495-751a-8b7a-2f8cfe6ec1de.webp",
      "image_media": {
        "alt_text": "Gym with weight machines and cardio equipment",
        "public_id": "019d08a9-6495-751a-8b7a-2f8cfe6ec1de",
        "storage_key": "property/6767906449166879/019d08a9-6495-751a-8b7a-2f8cfe6ec1de.webp",
        "width": 972,
        "height": 683
      },
      "title": "Community",
      "description": "Fully equipped fitness center with weight machines and cardio equipment for residents.",
      "link": "false",
      "alt_text": "Gym with weight machines and cardio equipment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_FitnessCenter.jpg"
    },
    {
      "id": "ec_6beb9c38e0e180b760505c4b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-765b-77aa-ad3b-3444c68236d3.webp",
      "image_media": {
        "alt_text": "Amazon Hub package locker system with a digital screen and keypad.",
        "public_id": "019d08a9-765b-77aa-ad3b-3444c68236d3",
        "storage_key": "property/6767906449166879/019d08a9-765b-77aa-ad3b-3444c68236d3.webp",
        "width": 2304,
        "height": 3072
      },
      "title": "Community",
      "description": "Secure and convenient Amazon Hub package lockers for residents, featuring a digital interface for easy package retrieval.",
      "link": "false",
      "alt_text": "Amazon Hub package locker system with a digital screen and keypad.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_24 Hour Package Lockers.jpg"
    },
    {
      "id": "ec_1da0f9d022c548eb532761da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-6e3e-70f5-b36e-ed2eff4d1e27.webp",
      "image_media": {
        "alt_text": "Wooden sauna with benches and a heater.",
        "public_id": "019d08a9-6e3e-70f5-b36e-ed2eff4d1e27",
        "storage_key": "property/6767906449166879/019d08a9-6e3e-70f5-b36e-ed2eff4d1e27.webp",
        "width": 1007,
        "height": 656
      },
      "title": "Community",
      "description": "Relax and unwind in the community sauna, featuring natural wood paneling and a soothing atmosphere.",
      "link": "false",
      "alt_text": "Wooden sauna with benches and a heater.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_Sauna.jpeg"
    },
    {
      "id": "ec_aa8a2aa3e7841172994c7e21",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-758b-733c-abc7-c6085c10a4bc.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a table with an umbrella.",
        "public_id": "019d08a9-758b-733c-abc7-c6085c10a4bc",
        "storage_key": "property/6767906449166879/019d08a9-758b-733c-abc7-c6085c10a4bc.webp",
        "width": 1014,
        "height": 661
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lounge chairs and lush greenery.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a table with an umbrella.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_OutdoorPool.jpg"
    },
    {
      "id": "ec_3b1d84b35fcf257c0147bcb3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-7271-70c0-9758-be72f48644af.webp",
      "image_media": {
        "alt_text": "Indoor swimming pool with wood-paneled walls and ceiling.",
        "public_id": "019d08a9-7271-70c0-9758-be72f48644af",
        "storage_key": "property/6767906449166879/019d08a9-7271-70c0-9758-be72f48644af.webp",
        "width": 640,
        "height": 480
      },
      "title": "Community",
      "description": "Enjoy a relaxing swim in our indoor pool, perfect for year-round enjoyment. The pool area features comfortable seating and large windows overlooking the surrounding greenery.",
      "link": "false",
      "alt_text": "Indoor swimming pool with wood-paneled walls and ceiling.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_IndoorPool.jpg"
    },
    {
      "id": "ec_7486a4436d41e4fdc3768c7d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-87f9-74d7-8c5d-db69bd7c4aad.webp",
      "image_media": {
        "alt_text": "Playground with slides and swings adjacent to apartment buildings.",
        "public_id": "019d08a9-87f9-74d7-8c5d-db69bd7c4aad",
        "storage_key": "property/6767906449166879/019d08a9-87f9-74d7-8c5d-db69bd7c4aad.webp",
        "width": 1029,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, perfect for families with children. Located conveniently near apartment buildings.",
      "link": "false",
      "alt_text": "Playground with slides and swings adjacent to apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_Playground.jpg"
    },
    {
      "id": "ec_6c5dd0d03fc5588e63605f2a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-8e4d-7240-943c-36101406af4c.webp",
      "image_media": {
        "alt_text": "Basketball court and playground with apartment buildings in the background.",
        "public_id": "019d08a9-8e4d-7240-943c-36101406af4c",
        "storage_key": "property/6767906449166879/019d08a9-8e4d-7240-943c-36101406af4c.webp",
        "width": 1029,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with a basketball court and playground for residents of all ages. Perfect for staying active and having fun.",
      "link": "false",
      "alt_text": "Basketball court and playground with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_BasketballCourt01.jpg"
    },
    {
      "id": "ec_98a41a1592cc12e91bd3cf54",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-8565-711b-8106-cb81a5df8926.webp",
      "image_media": {
        "alt_text": "Basketball court and picnic area with picnic tables and grills.",
        "public_id": "019d08a9-8565-711b-8106-cb81a5df8926",
        "storage_key": "property/6767906449166879/019d08a9-8565-711b-8106-cb81a5df8926.webp",
        "width": 640,
        "height": 480
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation at our community basketball court and picnic area, complete with tables and grills for gatherings.",
      "link": "false",
      "alt_text": "Basketball court and picnic area with picnic tables and grills.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_PicnicArea.jpg"
    },
    {
      "id": "ec_2d6d377010d8c9a4e76eb653",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-896c-7467-8cef-ca1021fb90c9.webp",
      "image_media": {
        "alt_text": "Exterior building view with flowering bushes and trees.",
        "public_id": "019d08a9-896c-7467-8cef-ca1021fb90c9",
        "storage_key": "property/6767906449166879/019d08a9-896c-7467-8cef-ca1021fb90c9.webp",
        "width": 640,
        "height": 480
      },
      "title": "Community",
      "description": "Beautiful exterior view of the apartment buildings surrounded by lush greenery and vibrant flowering bushes.",
      "link": "false",
      "alt_text": "Exterior building view with flowering bushes and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_Exterior01.jpg"
    },
    {
      "id": "ec_231888502142dfc66733b173",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-966b-71fd-95b7-f0c11219f7a2.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with balconies and red flowering bush.",
        "public_id": "019d08a9-966b-71fd-95b7-f0c11219f7a2",
        "storage_key": "property/6767906449166879/019d08a9-966b-71fd-95b7-f0c11219f7a2.webp",
        "width": 640,
        "height": 480
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring private balconies, lush landscaping, and vibrant flowering bushes.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with balconies and red flowering bush.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_Exterior03.jpg"
    },
    {
      "id": "ec_0a4c2799436c2ccafafcc40f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "title": "Community",
      "description": "Beautiful apartment buildings with private balconies and lush greenery, offering a serene living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_Exterior02.jpg"
    },
    {
      "id": "ec_3232993706501ff2f3c1f931",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9b86-721a-8293-e214b9203f20.webp",
      "image_media": {
        "alt_text": "Snow-capped mountain peak visible through evergreen trees under a blue sky.",
        "public_id": "019d08a9-9b86-721a-8293-e214b9203f20",
        "storage_key": "property/6767906449166879/019d08a9-9b86-721a-8293-e214b9203f20.webp",
        "width": 640,
        "height": 480
      },
      "title": "Community",
      "description": "Experience the beauty of nature with a stunning view of a snow-capped mountain, framed by lush evergreen trees. A perfect escape into serenity.",
      "link": "false",
      "alt_text": "Snow-capped mountain peak visible through evergreen trees under a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Chambers Creek_University Place_WA_View.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_fd8137dc-264e-4fb7-92db-078bf35674ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Harvest Buffet",
      "poi_type": "Restaurants",
      "poi_address": "3121 S 38th St, Tacoma, WA 98409, USA",
      "poi_short_description": "Spacious, informal restaurant offering an all-you-can-eat buffet of typical Asian dishes & desserts.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of fresh food, including sushi, seafood, and a Mongolian grill. They also highlight the reasonable prices, the clean and modern atmosphere, and the friendly staff.\n\nOther reviews mention the restaurant can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-0165-7128-b931-516f568343f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-0165-7128-b931-516f568343f4",
        "storage_key": "property/6767906449166879/019d08ab-0165-7128-b931-516f568343f4.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "http://www.harvestbuffettacoma.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3188859851387742195&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harvest-buffet",
      "poi_latitude": "47.2237319",
      "poi_longitude": "-122.4775848",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-472-3888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b227-7659-b168-9e1484977aab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b227-7659-b168-9e1484977aab",
        "storage_key": "property/6767906449166879/019d08aa-b227-7659-b168-9e1484977aab.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRqPizurkVQR86d4uCMbQSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_866ee53d-5723-480f-80c4-0fb8612315b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Matador Tacoma",
      "poi_type": "Restaurants",
      "poi_address": "721 Pacific Ave, Tacoma, WA 98402, USA",
      "poi_short_description": "Local bar chain serving classic & contemporary Mexican dishes, plus cocktails, in a stylish space.",
      "poi_long_description": "Diners say this Mexican restaurant serves up delicious brussel sprouts, fish tacos, and carne asada, and they praise the extensive tequila selection and tasty margaritas. They also highlight the friendly and attentive service, reasonable prices, generous happy hour portions, and inviting atmosphere, especially around the fireplace.\n\nSome reviews mention the parking can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-00f7-7589-905c-f3b5abfceeb3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-00f7-7589-905c-f3b5abfceeb3",
        "storage_key": "property/6767906449166879/019d08ab-00f7-7589-905c-f3b5abfceeb3.webp",
        "width": 1126,
        "height": 751
      },
      "poi_business_url": "https://matadorrestaurants.com/locations/tacoma",
      "poi_directions_map_url": "https://maps.google.com/?cid=3823531445110426895&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "matador-tacoma",
      "poi_latitude": "47.2566835",
      "poi_longitude": "-122.4391313",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 253-627-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b227-7659-b168-9e1484977aab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b227-7659-b168-9e1484977aab",
        "storage_key": "property/6767906449166879/019d08aa-b227-7659-b168-9e1484977aab.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJQLIIKFVkFQRD81XZZfpDzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_32bb33b0-cd7d-44ac-a022-78b5176cf353",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Duke's Seafood Tacoma",
      "poi_type": "Restaurants",
      "poi_address": "3327 Ruston Way, Tacoma, WA 98402, USA",
      "poi_short_description": "Local chain serving market-fresh seafood, grass-fed burgers & cocktails in informal surroundings.",
      "poi_long_description": "People say this seafood restaurant serves delicious clam chowder, crab cakes, and fish and chips. They highlight the fresh seafood, generous portions, and beautiful waterfront views, especially from the outdoor deck. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-0127-77d8-a576-86ad3857c97e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-0127-77d8-a576-86ad3857c97e",
        "storage_key": "property/6767906449166879/019d08ab-0127-77d8-a576-86ad3857c97e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.dukesseafood.com/locations/tacoma?utm_source=gmb&utm_medium=organic&utm_campaign=gmb-tracking&utm_term=tacoma",
      "poi_directions_map_url": "https://maps.google.com/?cid=6058170926971419685&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dukes-seafood-tacoma",
      "poi_latitude": "47.2825834",
      "poi_longitude": "-122.4798449",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 253-752-5444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b227-7659-b168-9e1484977aab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b227-7659-b168-9e1484977aab",
        "storage_key": "property/6767906449166879/019d08aa-b227-7659-b168-9e1484977aab.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh6xeOvVUkFQRJfy6SlzyElQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_0e9f08a5-de4f-4715-8b76-2ed78b4ef8b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "5429 100th St SW, Lakewood, WA 98499, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves tasty food, including fries with buffalo sauce. They also highlight the friendly and helpful staff, and the positive and fun atmosphere.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-0aa9-74da-900e-08304c242039.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-0aa9-74da-900e-08304c242039",
        "storage_key": "property/6767906449166879/019d08ab-0aa9-74da-900e-08304c242039.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/wa/bridgeport-100th?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=9299915961675767711&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "47.1670549",
      "poi_longitude": "-122.5092631",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 253-582-2696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b227-7659-b168-9e1484977aab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b227-7659-b168-9e1484977aab",
        "storage_key": "property/6767906449166879/019d08aa-b227-7659-b168-9e1484977aab.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVFm-EAkVQRn1-rSEvwD4E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_fe5a1c55-5089-40b9-94b6-3d8e03cb4438",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Tacoma Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "4502 S Steele St, Tacoma, WA 98409, USA",
      "poi_short_description": "Clothing chain with trendy apparel, shoes & accessories for teen girls & young women.",
      "poi_long_description": "People say this shopping center offers a wide variety of clothing and food options, and has a free indoor play area for children. They also highlight the clean restrooms, the safe and secure environment, and the helpful staff.\n\nSome reviews mention parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-41d8-747a-aa16-6510fb06a82b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08aa-41d8-747a-aa16-6510fb06a82b",
        "storage_key": "property/6767906449166879/019d08aa-41d8-747a-aa16-6510fb06a82b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.simon.com/mall/tacoma-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6869659206638140388&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tacoma-mall",
      "poi_latitude": "47.2160921",
      "poi_longitude": "-122.4687412",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 253-475-4565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b919-72aa-9561-1e807660b53c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b919-72aa-9561-1e807660b53c",
        "storage_key": "property/6767906449166879/019d08aa-b919-72aa-9561-1e807660b53c.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEaqbEgIAkVQR5Huow6buVV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_46d2985c-7d43-4f22-a4fb-c8d35e581ff6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "3515 Bridgeport Way W, University Place, WA 98466, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh produce, seafood, and meat, as well as a hot bar, deli, and coffee bar. They also highlight the friendly and helpful staff, and the clean and welcoming environment.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-0b9a-733a-872c-e3063c0d55f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-0b9a-733a-872c-e3063c0d55f7",
        "storage_key": "property/6767906449166879/019d08ab-0b9a-733a-872c-e3063c0d55f7.webp",
        "width": 1280,
        "height": 692
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/chambersbay?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=15084516739865936928&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "47.2271466",
      "poi_longitude": "-122.5360325",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 253-534-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b40a-70ea-bab6-9417eba9ccb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b40a-70ea-bab6-9417eba9ccb3",
        "storage_key": "property/6767906449166879/019d08aa-b40a-70ea-bab6-9417eba9ccb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaXzGB-6qkVQRIIQkwA34VtE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f3d09d44-5b57-4919-b0d4-7ba4464df6d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "3800 Bridgeport Way W, University Place, WA 98466, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy foods, fresh produce, snacks, and flowers. They highlight the reasonable prices, fun finds, and the consistently excellent quality of the products. They also like the friendly, helpful, and upbeat staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-34b6-7228-8f85-89fe0a923fda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08aa-34b6-7228-8f85-89fe0a923fda",
        "storage_key": "property/6767906449166879/019d08aa-34b6-7228-8f85-89fe0a923fda.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/wa/university-place/148/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16532301060385539710&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "47.2229584",
      "poi_longitude": "-122.5378689",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 253-460-2672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b40a-70ea-bab6-9417eba9ccb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b40a-70ea-bab6-9417eba9ccb3",
        "storage_key": "property/6767906449166879/019d08aa-b40a-70ea-bab6-9417eba9ccb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhfHP3_KqkVQRfgYY-DiIbuU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_36387f8c-f028-40c6-b8d9-88df6f1318b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "1913 S 72nd St, Tacoma, WA 98408, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide selection of groceries, including bulk foods and produce. They also highlight the low prices and the friendly staff.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-0ba9-77b3-a025-884e7d6c75a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-0ba9-77b3-a025-884e7d6c75a0",
        "storage_key": "property/6767906449166879/019d08ab-0ba9-77b3-a025-884e7d6c75a0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10993939095152252900&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "47.195192",
      "poi_longitude": "-122.459911",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-830-3005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b40a-70ea-bab6-9417eba9ccb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b40a-70ea-bab6-9417eba9ccb3",
        "storage_key": "property/6767906449166879/019d08aa-b40a-70ea-bab6-9417eba9ccb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjbWeSjsAkVQR5FfU0FtRkpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_51a7f188-d3e0-42ad-be45-cffeac16100b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "H Mart Tacoma",
      "poi_type": "Shopping & Retail",
      "poi_address": "8720 S Tacoma Way, Lakewood, WA 98499, USA",
      "poi_short_description": "Asian grocery store chain supplying imported packaged foods & housewares plus ready-to-serve meals.",
      "poi_long_description": "People say this Korean grocery store offers a wide variety of fresh produce, seafood, snacks, and ramen, as well as a bakery with delicious pastries. They also highlight the decent prices, especially on produce, and the friendly, helpful staff.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-0cfe-73ca-8156-11f1a4657eb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-0cfe-73ca-8156-11f1a4657eb6",
        "storage_key": "property/6767906449166879/019d08ab-0cfe-73ca-8156-11f1a4657eb6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hmartus.com/tacoma",
      "poi_directions_map_url": "https://maps.google.com/?cid=13925351037816439562&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "h-mart-tacoma",
      "poi_latitude": "47.178507",
      "poi_longitude": "-122.4851458",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 253-314-5066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b40a-70ea-bab6-9417eba9ccb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b40a-70ea-bab6-9417eba9ccb3",
        "storage_key": "property/6767906449166879/019d08aa-b40a-70ea-bab6-9417eba9ccb3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJTZrVFEAkVQRCoOqPf3IQME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_cb214f14-a9b3-4cc0-9b42-7a8f3254cc06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Tacoma Community College",
      "poi_type": "Education",
      "poi_address": "6501 S 19th St, Tacoma, WA 98466, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-ab4e-717a-ae50-8647d5832836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08aa-ab4e-717a-ae50-8647d5832836",
        "storage_key": "property/6767906449166879/019d08aa-ab4e-717a-ae50-8647d5832836.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.tacomacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=602570984518978676&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tacoma-community-college",
      "poi_latitude": "47.2462328",
      "poi_longitude": "-122.5219935",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 253-566-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-ba98-776c-b370-1275d5c5cc24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-ba98-776c-b370-1275d5c5cc24",
        "storage_key": "property/6767906449166879/019d08aa-ba98-776c-b370-1275d5c5cc24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbz1it9eqkVQRdAw2LB7DXAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bae4e4a1-ce60-4c2c-a51d-7da897d89178",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "University of Washington Tacoma",
      "poi_type": "Education",
      "poi_address": "1900 Commerce St, Tacoma, WA 98402, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-a47e-72cf-9e59-4d93a0e85f4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08aa-a47e-72cf-9e59-4d93a0e85f4f",
        "storage_key": "property/6767906449166879/019d08aa-a47e-72cf-9e59-4d93a0e85f4f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tacoma.uw.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8015147170715330239&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-washington-tacoma",
      "poi_latitude": "47.2454407",
      "poi_longitude": "-122.4385162",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 253-692-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-ba98-776c-b370-1275d5c5cc24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-ba98-776c-b370-1275d5c5cc24",
        "storage_key": "property/6767906449166879/019d08aa-ba98-776c-b370-1275d5c5cc24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWzChLXdVkFQRv-b2vOKFO28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1a0f974f-6547-4afa-8dae-31b01385ef18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "University of Puget Sound",
      "poi_type": "Education",
      "poi_address": "1500 N Warner St, Tacoma, WA 98416, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-51dc-7652-9a7b-5844acb25277.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08aa-51dc-7652-9a7b-5844acb25277",
        "storage_key": "property/6767906449166879/019d08aa-51dc-7652-9a7b-5844acb25277.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.pugetsound.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5089139173331474544&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-puget-sound",
      "poi_latitude": "47.2617495",
      "poi_longitude": "-122.4814442",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 253-879-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-ba98-776c-b370-1275d5c5cc24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-ba98-776c-b370-1275d5c5cc24",
        "storage_key": "property/6767906449166879/019d08aa-ba98-776c-b370-1275d5c5cc24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVVVlQpVkFQRcJjyXh1BoEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ee1cc80d-afad-4f2f-b736-836edc16757e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Pacific Lutheran University",
      "poi_type": "Education",
      "poi_address": "12180 Park Ave. S, Tacoma, WA 98447, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-176b-743c-b82c-aeca765dbd13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-176b-743c-b82c-aeca765dbd13",
        "storage_key": "property/6767906449166879/019d08ab-176b-743c-b82c-aeca765dbd13.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "http://www.plu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4175111740689180711&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pacific-lutheran-university",
      "poi_latitude": "47.14519310000001",
      "poi_longitude": "-122.4436669",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 253-535-7411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-ba98-776c-b370-1275d5c5cc24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-ba98-776c-b370-1275d5c5cc24",
        "storage_key": "property/6767906449166879/019d08aa-ba98-776c-b370-1275d5c5cc24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7f9NLYEBkVQRJ2hX6QH68Dk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_cca10ea4-790c-4f45-a33e-7e7dba5f0e36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Pierce College Fort Steilacoom",
      "poi_type": "Education",
      "poi_address": "9401 Farwest Dr SW, Lakewood, WA 98498, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-1693-70a3-acd2-ce3fed57331d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-1693-70a3-acd2-ce3fed57331d",
        "storage_key": "property/6767906449166879/019d08ab-1693-70a3-acd2-ce3fed57331d.webp",
        "width": 854,
        "height": 1280
      },
      "poi_business_url": "https://www.pierce.ctc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1357299788340593001&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pierce-college-fort-steilacoom",
      "poi_latitude": "47.1714455",
      "poi_longitude": "-122.5714641",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 253-964-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-ba98-776c-b370-1275d5c5cc24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-ba98-776c-b370-1275d5c5cc24",
        "storage_key": "property/6767906449166879/019d08aa-ba98-776c-b370-1275d5c5cc24.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_Tzb_EsHkVQRaQHBWfcY1hI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a866fe15-c71f-4b5e-b3e0-359bb031c6fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Cheney Stadium",
      "poi_type": "Entertainment",
      "poi_address": "2502 S Tyler St, Tacoma, WA 98405, USA",
      "poi_short_description": "Minor-league baseball stadium, home to the Tacoma Rainiers, with a Mt. Rainier view & luxury suites.",
      "poi_long_description": "Fans say this ballpark offers a fun, family-friendly experience with exciting minor league baseball, delicious food options, and spectacular fireworks shows. They also highlight the friendly and helpful staff, affordable tickets, and clean facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-1737-734d-8cf0-bd0eeea86770.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-1737-734d-8cf0-bd0eeea86770",
        "storage_key": "property/6767906449166879/019d08ab-1737-734d-8cf0-bd0eeea86770.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.milb.com/tacoma/ballpark/cheney-stadium",
      "poi_directions_map_url": "https://maps.google.com/?cid=4065610704513121264&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheney-stadium",
      "poi_latitude": "47.2378167",
      "poi_longitude": "-122.4977467",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-752-7707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-4d59-77ff-b6fe-e8431009ff79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-4d59-77ff-b6fe-e8431009ff79",
        "storage_key": "property/6767906449166879/019d08ab-4d59-77ff-b6fe-e8431009ff79.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGaxAR8uqkVQR8LuHLWXzazg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_85d45322-e42a-4474-a4c0-4c6b3f09f09f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Museum of Glass",
      "poi_type": "Entertainment",
      "poi_address": "1801 Dock St, Tacoma, WA 98402, USA",
      "poi_short_description": "Diverse indoor & outdoor glass-art exhibits plus a cone-shaped studio with working artists.",
      "poi_long_description": "People say this art museum showcases beautiful glass art pieces and offers live glass blowing demonstrations. They highlight the mesmerizing experience of watching artists work with molten glass, the diverse range of contemporary glass art, and the unique cone structure of the building. They also like the interactive elements, educational displays, and the Chihuly Bridge of Glass.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-5b38-772a-897a-a804ed814b4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08aa-5b38-772a-897a-a804ed814b4b",
        "storage_key": "property/6767906449166879/019d08aa-5b38-772a-897a-a804ed814b4b.webp",
        "width": 1280,
        "height": 919
      },
      "poi_business_url": "https://www.museumofglass.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12420455278076938078&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "museum-of-glass",
      "poi_latitude": "47.24550079999999",
      "poi_longitude": "-122.4340189",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 253-284-4750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-bf97-710b-9e65-2d21b42b2b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-bf97-710b-9e65-2d21b42b2b4b",
        "storage_key": "property/6767906449166879/019d08aa-bf97-710b-9e65-2d21b42b2b4b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJGTMDr3dVkFQRXsdm3kRSXqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c8424838-33a5-49b5-9a9e-5686d9aa86a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "LeMay - America’s Car Museum",
      "poi_type": "Entertainment",
      "poi_address": "2702 E D St, Tacoma, WA 98421, USA",
      "poi_short_description": "4-story museum on an 8-acre campus displays cars, trucks & motorcycles in historic & tech exhibits.",
      "poi_long_description": "People say this museum offers a large and diverse collection of classic, vintage, and rare cars, as well as racing simulators and a gift shop. They highlight the spacious layout, the friendly and knowledgeable staff, and the fun, family-friendly atmosphere. They also like the free parking and the rotating exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-62a2-75fb-b41e-891a497abd38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08aa-62a2-75fb-b41e-891a497abd38",
        "storage_key": "property/6767906449166879/019d08aa-62a2-75fb-b41e-891a497abd38.webp",
        "width": 729,
        "height": 521
      },
      "poi_business_url": "http://www.americascarmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17839745701636681105&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lemay---americas-car-museum",
      "poi_latitude": "47.2357021",
      "poi_longitude": "-122.4303288",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-779-8490",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-bf97-710b-9e65-2d21b42b2b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-bf97-710b-9e65-2d21b42b2b4b",
        "storage_key": "property/6767906449166879/019d08aa-bf97-710b-9e65-2d21b42b2b4b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJWR-QTHxVkFQRkS1bVTKCk_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_860ecb66-b6ca-4211-ada7-69bc0e9fa01c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Children's Museum of Tacoma",
      "poi_type": "Entertainment",
      "poi_address": "1501 Pacific Ave, Tacoma, WA 98402, USA",
      "poi_short_description": "Museum with 5 playscapes offering hands-on exploration designed to entertain & educate children.",
      "poi_long_description": "Visitors say this children's museum offers a variety of play areas, including an art room, climbing area, and water play, and is a great place for kids to explore and learn. They also highlight the museum's pay-as-you-can admission, making it accessible for families on a budget, and the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-6add-762b-bf88-812f6ba365ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08aa-6add-762b-bf88-812f6ba365ce",
        "storage_key": "property/6767906449166879/019d08aa-6add-762b-bf88-812f6ba365ce.webp",
        "width": 1263,
        "height": 710
      },
      "poi_business_url": "http://greentrike.org/childrens-museum-of-tacoma",
      "poi_directions_map_url": "https://maps.google.com/?cid=1983464320316777643&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "childrens-museum-of-tacoma",
      "poi_latitude": "47.2489636",
      "poi_longitude": "-122.4373771",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-627-6031",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-bf97-710b-9e65-2d21b42b2b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-bf97-710b-9e65-2d21b42b2b4b",
        "storage_key": "property/6767906449166879/019d08aa-bf97-710b-9e65-2d21b42b2b4b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cHieaBVkFQRq6QkXUquhhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_c36c130c-cd37-4000-83ba-06abb07a9881",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Tacoma Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "1701 Pacific Ave, Tacoma, WA 98402, USA",
      "poi_short_description": "Exhibits feature Dale Chihuly glass works, European Impressionism, Japanese prints & American art.",
      "poi_long_description": "People say this art museum offers a good variety of exhibits, including student-made items in the gift shop. They highlight the reasonable prices, convenient parking, and easy navigation. They also like the friendly and helpful staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-6135-74ee-b176-ab2ed94fb80c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08aa-6135-74ee-b176-ab2ed94fb80c",
        "storage_key": "property/6767906449166879/019d08aa-6135-74ee-b176-ab2ed94fb80c.webp",
        "width": 1280,
        "height": 680
      },
      "poi_business_url": "http://www.tacomaartmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3943333449812358662&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tacoma-art-museum",
      "poi_latitude": "47.2473997",
      "poi_longitude": "-122.4368025",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 253-272-4258",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-bf97-710b-9e65-2d21b42b2b4b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-bf97-710b-9e65-2d21b42b2b4b",
        "storage_key": "property/6767906449166879/019d08aa-bf97-710b-9e65-2d21b42b2b4b.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJswi_f3ZVkFQRBjb7QuGIuTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a8d9edd8-d4aa-451d-9668-97490dceaadc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Summit Veterinary Referral Center",
      "poi_type": "Health and Wellness",
      "poi_address": "2505 S 80th St, Tacoma, WA 98409, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-1eb8-7143-b259-aa9c05443684.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-1eb8-7143-b259-aa9c05443684",
        "storage_key": "property/6767906449166879/019d08ab-1eb8-7143-b259-aa9c05443684.webp",
        "width": 1280,
        "height": 949
      },
      "poi_business_url": "https://www.summitvets.com/?y_source=1_MTE2Njg4NjItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11974744133540247188&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "summit-veterinary-referral-center",
      "poi_latitude": "47.18519269999999",
      "poi_longitude": "-122.4707177",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 253-983-1114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b22d-7158-a776-be2cd6a97445",
        "storage_key": "property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1c-NqkkAkVQRlPbbM1jWLqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_25ff1621-cfe7-458d-9093-e30658634a49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "111 S 38th St, Tacoma, WA 98418, USA",
      "poi_short_description": "Membership-only chain fitness center offering cardio and weight equipment, an indoor pool, and 24/7 access.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-1fd3-76e8-9b48-27dfa649e9ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-1fd3-76e8-9b48-27dfa649e9ea",
        "storage_key": "property/6767906449166879/019d08ab-1fd3-76e8-9b48-27dfa649e9ea.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/tacoma-wa/tacoma-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=414306649313173586&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "47.2241978",
      "poi_longitude": "-122.4321077",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-240-3483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b22d-7158-a776-be2cd6a97445",
        "storage_key": "property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLWkr0I3_kFQRUuBk1LPpvwU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f398a3f7-78c9-44cc-b124-b9f158856b65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "BluePearl Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2510 S 84th St Ste. 30D, Lakewood, WA 98499, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-2046-72db-9859-d5a131105a14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-2046-72db-9859-d5a131105a14",
        "storage_key": "property/6767906449166879/019d08ab-2046-72db-9859-d5a131105a14.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://bluepearlvet.com/hospital/tacoma-wa/?utm_source=maps&utm_medium=google&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=13887823140716947476&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluepearl-pet-hospital",
      "poi_latitude": "47.18002689999999",
      "poi_longitude": "-122.4702102",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 253-474-0791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b22d-7158-a776-be2cd6a97445",
        "storage_key": "property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZNaCQ0AkVQRFCjizZB1u8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_a93a9fae-ce48-44c6-9e7c-0590e06b21af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1905B S 72nd St, Tacoma, WA 98408, USA",
      "poi_short_description": "Chain fitness center with cardio and weight machines, a pool, and basketball courts, plus group classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-20bc-703f-ac08-d146e0baec54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-20bc-703f-ac08-d146e0baec54",
        "storage_key": "property/6767906449166879/019d08ab-20bc-703f-ac08-d146e0baec54.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1261&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=13639371398038297313&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.1933519",
      "poi_longitude": "-122.4601056",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 253-533-9387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b22d-7158-a776-be2cd6a97445",
        "storage_key": "property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7WCDJjcAkVQR4RqyowXISL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_712a8621-6504-4911-8dcb-d9ecae513074",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Union Salon",
      "poi_type": "Health and Wellness",
      "poi_address": "708 Opera Aly, Tacoma, WA 98402, USA",
      "poi_short_description": "Relaxed, upscale salon for cuts, coloring and styling services, plus hair-care products.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-27e2-7260-b166-f132026edeca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-27e2-7260-b166-f132026edeca",
        "storage_key": "property/6767906449166879/019d08ab-27e2-7260-b166-f132026edeca.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://uniontacoma.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3572464139224888116&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "union-salon",
      "poi_latitude": "47.25727939999999",
      "poi_longitude": "-122.4418586",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 253-327-1484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b22d-7158-a776-be2cd6a97445",
        "storage_key": "property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2Y_DM6dVkFQRNDNS9zTxkzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_2ffefb62-995c-4313-930a-24ca2098f1ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "University YMCA Student Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1710 Market St, Tacoma, WA 98402, USA",
      "poi_short_description": "Branch of the Family YMCA chain located inside the University Y Student Center in New Tacoma.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-27a0-76a8-9fcd-4e19ef048019.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-27a0-76a8-9fcd-4e19ef048019",
        "storage_key": "property/6767906449166879/019d08ab-27a0-76a8-9fcd-4e19ef048019.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.ymcapkc.org/locations/university-ymca-student-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=569589627320068484&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-ymca-student-center",
      "poi_latitude": "47.2463039",
      "poi_longitude": "-122.4404075",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 253-272-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b22d-7158-a776-be2cd6a97445",
        "storage_key": "property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN44xq3ZVkFQRhOkojL-W5wc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_3b075fcb-ddca-4bda-b00e-cc98207af44f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "817 E 72nd St, Tacoma, WA 98404, USA",
      "poi_short_description": "Chain gym with a spa area, tanning beds, and massage chairs, open for long hours.",
      "poi_long_description": "People say this gym offers a wide variety of machines and equipment, including Smith machines, and has a 30-minute circuit training area. They highlight the clean and well-maintained facilities, and the friendly and helpful staff. They also like the positive and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-7e71-743b-aeea-238065c236e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08aa-7e71-743b-aeea-238065c236e0",
        "storage_key": "property/6767906449166879/019d08aa-7e71-743b-aeea-238065c236e0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/tacoma-eastside-wa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4740775242515932458&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.19208769999999",
      "poi_longitude": "-122.419927",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 253-475-5689",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b22d-7158-a776-be2cd6a97445",
        "storage_key": "property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBTKIRC3-kFQRKuUgIvedykE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_462e2334-0b40-459a-8942-e2eb65f54726",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "4502 S Steele St STE 1660, Tacoma, WA 98409, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-2829-77c6-a23f-cf1d34a3fd04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-2829-77c6-a23f-cf1d34a3fd04",
        "storage_key": "property/6767906449166879/019d08ab-2829-77c6-a23f-cf1d34a3fd04.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tacoma-wa-1550",
      "poi_directions_map_url": "https://maps.google.com/?cid=1764574433925063063&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "47.2178151",
      "poi_longitude": "-122.4653979",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 253-317-2978",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b22d-7158-a776-be2cd6a97445",
        "storage_key": "property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SV5bar_kFQRl-HWORkHfRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_267a13a5-e4b9-4b14-bf12-db0df273ea74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "St. Joseph Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1717 S J St, Tacoma, WA 98405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-7408-73d8-95a6-cb78051f7d36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08aa-7408-73d8-95a6-cb78051f7d36",
        "storage_key": "property/6767906449166879/019d08aa-7408-73d8-95a6-cb78051f7d36.webp",
        "width": 1280,
        "height": 1060
      },
      "poi_business_url": "https://www.vmfh.org/our-hospitals/st-joseph-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=1086247563015510942&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "st-joseph-medical-center",
      "poi_latitude": "47.24549409999999",
      "poi_longitude": "-122.4479997",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 253-426-4101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-c027-762b-a4af-7667a0262aa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-c027-762b-a4af-7667a0262aa6",
        "storage_key": "property/6767906449166879/019d08aa-c027-762b-a4af-7667a0262aa6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8dbfYXJVkFQRnlusQ2cgEw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_005041df-afb1-4803-a0ef-bfeb8e948d87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "MultiCare Tacoma General Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "315 M.L.K. Jr Way, Tacoma, WA 98405, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-73ff-70cc-8704-b69d8afd34ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08aa-73ff-70cc-8704-b69d8afd34ae",
        "storage_key": "property/6767906449166879/019d08aa-73ff-70cc-8704-b69d8afd34ae.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.multicare.org/location/tacoma-general-hospital/?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=2281678395220750182&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "multicare-tacoma-general-hospital",
      "poi_latitude": "47.2595367",
      "poi_longitude": "-122.4529018",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 253-403-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-c027-762b-a4af-7667a0262aa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-c027-762b-a4af-7667a0262aa6",
        "storage_key": "property/6767906449166879/019d08aa-c027-762b-a4af-7667a0262aa6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJYwARMQZVkFQRZu_QXmkmqh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bb26a37e-edaf-492f-af35-8988b946e241",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Chambers Bay Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6320 Grandview Dr W, University Place, WA 98467, USA",
      "poi_short_description": "This public course designed by renowned golf architect Robert Trent Jones Jr has hosted the US Open.",
      "poi_long_description": "People say this public golf course offers a challenging and scenic walk with breathtaking views, and a well-stocked pro shop. They highlight the friendly staff, knowledgeable caddies, and the availability of a shuttle service to and from the course. They also like the delicious food and the option to enjoy a Chambers Bay Bourbon.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-5801-719c-90c6-f2da96e735fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08aa-5801-719c-90c6-f2da96e735fd",
        "storage_key": "property/6767906449166879/019d08aa-5801-719c-90c6-f2da96e735fd.webp",
        "width": 1280,
        "height": 320
      },
      "poi_business_url": "http://www.chambersbaygolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16448961189655971989&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chambers-bay-golf-course",
      "poi_latitude": "47.2003276",
      "poi_longitude": "-122.5707511",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 253-460-4653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-bad8-717f-9a03-77b67a255231.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-bad8-717f-9a03-77b67a255231",
        "storage_key": "property/6767906449166879/019d08aa-bad8-717f-9a03-77b67a255231.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJkQPwfHOqkVQRlYihOQ1zRuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_104b3b49-f53e-4f2a-9358-ae0f981314c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Fort Steilacoom Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8714 87th Ave SW, Lakewood, WA 98498, USA",
      "poi_short_description": "Large area with baseball, softball & soccer fields, plus hiking paths, play sets & a dog park.",
      "poi_long_description": "People say this park offers walking trails, open fields, sports courts, a dog park, and a lake. They highlight the clean, safe, and well-maintained environment, and the spaciousness for picnics, playground activities, and strolls. They also like the historic character and modern, vibrant community atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-3070-750f-aa2d-1ab817f2aaa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-3070-750f-aa2d-1ab817f2aaa2",
        "storage_key": "property/6767906449166879/019d08ab-3070-750f-aa2d-1ab817f2aaa2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cityoflakewood.us/fort-steilacoom-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13705637693464897240&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-steilacoom-park",
      "poi_latitude": "47.17675380000001",
      "poi_longitude": "-122.5553595",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 253-983-7887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-be5b-7323-938b-0efc90b63b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-be5b-7323-938b-0efc90b63b9d",
        "storage_key": "property/6767906449166879/019d08aa-be5b-7323-938b-0efc90b63b9d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMWTleMoAkVQR2OYt2900NL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e1bec0c1-f88c-498b-9960-74091aceadaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Meadow Park Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7108 Lakewood Dr W, Tacoma, WA 98467, USA",
      "poi_short_description": "Golfing facility with a driving range, restaurant, and pro shop.",
      "poi_long_description": "People say this golf course offers a fun and challenging course, a large practice area with putting and chipping greens, and a heated driving range. They highlight the affordable prices, great value, and well-maintained facilities. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-3124-712e-bd87-4db8f586288d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-3124-712e-bd87-4db8f586288d",
        "storage_key": "property/6767906449166879/019d08ab-3124-712e-bd87-4db8f586288d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.parkstacoma.gov/meadow-park-golf-course/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16255727968687170698&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "meadow-park-golf-course",
      "poi_latitude": "47.1928204",
      "poi_longitude": "-122.510123",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 253-473-3033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-bad8-717f-9a03-77b67a255231.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-bad8-717f-9a03-77b67a255231",
        "storage_key": "property/6767906449166879/019d08aa-bad8-717f-9a03-77b67a255231.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJvTINLX0AkVQRiiT7Anbyl-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_89a6fa1f-736a-4eb1-a447-05dcf6471456",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Wapato Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6500 S Sheridan Ave, Tacoma, WA 98408, USA",
      "poi_short_description": "Urban park featuring a woodland area, a lake, walking trail & dog park, plus a historic pergola.",
      "poi_long_description": "People say this park offers a lake, walking trails, picnic areas, playgrounds, and dog parks, including an off-leash area. They highlight the peaceful and tranquil vibe, and the well-maintained grounds with plenty of green spaces. They also like the diverse activities, such as fishing and feeding ducks, and the family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-3250-71cc-8c78-8cb1da39f3c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-3250-71cc-8c78-8cb1da39f3c0",
        "storage_key": "property/6767906449166879/019d08ab-3250-71cc-8c78-8cb1da39f3c0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.metroparkstacoma.org/wapato-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15744537620839301556&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wapato-park",
      "poi_latitude": "47.1954541",
      "poi_longitude": "-122.4538614",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 253-305-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-be5b-7323-938b-0efc90b63b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-be5b-7323-938b-0efc90b63b9d",
        "storage_key": "property/6767906449166879/019d08aa-be5b-7323-938b-0efc90b63b9d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJi1A9_yQAkVQRtIHmSozVf9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a59ea526-148a-48aa-ae2e-f8f6ab92a3fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Wright Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "501 S I St, Tacoma, WA 98405, USA",
      "poi_short_description": "Greenspace with a vast collection of trees, plus a trail, playgrounds, sport courts & picnic areas.",
      "poi_long_description": "Visitors say this park offers a beautiful arboretum with walking paths, a playground, a splash pad, and a pond. They also highlight the well-maintained grounds, abundance of shade trees, and the historic conservatory.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-3379-76ab-8e27-37b3cc3904fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-3379-76ab-8e27-37b3cc3904fa",
        "storage_key": "property/6767906449166879/019d08ab-3379-76ab-8e27-37b3cc3904fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metroparkstacoma.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18017825162376901426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wright-park",
      "poi_latitude": "47.2594789",
      "poi_longitude": "-122.4489414",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 253-305-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-be5b-7323-938b-0efc90b63b9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-be5b-7323-938b-0efc90b63b9d",
        "storage_key": "property/6767906449166879/019d08aa-be5b-7323-938b-0efc90b63b9d.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJocxN_wdVkFQRMvORzIUsDPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_603dd94f-416b-4d13-a080-215d7ad8dccb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Tacoma Dome",
      "poi_type": "Transportation & Transit",
      "poi_address": "422 E 25th St, Tacoma, WA 98421, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-395c-726e-be15-9060ab0146ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-395c-726e-be15-9060ab0146ca",
        "storage_key": "property/6767906449166879/019d08ab-395c-726e-be15-9060ab0146ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=TAC",
      "poi_directions_map_url": "https://maps.google.com/?cid=11981741027217255491&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tacoma-dome",
      "poi_latitude": "47.23968410000001",
      "poi_longitude": "-122.4281885",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-c5fd-715f-8a28-f3a1317c299b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-c5fd-715f-8a28-f3a1317c299b",
        "storage_key": "property/6767906449166879/019d08aa-c5fd-715f-8a28-f3a1317c299b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfRhf4FVkFQRQywCdvuxR6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_e966c7fa-59c1-4500-818f-017e55d10dfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Tacoma Narrows Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1202 26th Ave NW, Gig Harbor, WA 98335, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-3a17-71a9-bfed-56eba3177024.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-3a17-71a9-bfed-56eba3177024",
        "storage_key": "property/6767906449166879/019d08ab-3a17-71a9-bfed-56eba3177024.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.piercecountywa.gov/1624/Tacoma-Narrows-TIW",
      "poi_directions_map_url": "https://maps.google.com/?cid=13269735611620374170&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tacoma-narrows-airport",
      "poi_latitude": "47.2678293",
      "poi_longitude": "-122.577424",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 253-853-5844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-c634-7692-8725-f3fe185a5f1b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-c634-7692-8725-f3fe185a5f1b",
        "storage_key": "property/6767906449166879/019d08aa-c634-7692-8725-f3fe185a5f1b.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJBeio8markVQRmrb7kTuSJ7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_c8f784cc-8123-481c-9b0a-bd8e22ad8e03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Lakewood",
      "poi_type": "Transportation & Transit",
      "poi_address": "Lakewood, WA 98499, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-3c15-717c-86de-140ac2f46fb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-3c15-717c-86de-140ac2f46fb9",
        "storage_key": "property/6767906449166879/019d08ab-3c15-717c-86de-140ac2f46fb9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.soundtransit.org/Rider-Guide/Lakewood-Station",
      "poi_directions_map_url": "https://maps.google.com/?cid=9730188818233709121&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lakewood",
      "poi_latitude": "47.1529818",
      "poi_longitude": "-122.4993419",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-c5fd-715f-8a28-f3a1317c299b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-c5fd-715f-8a28-f3a1317c299b",
        "storage_key": "property/6767906449166879/019d08aa-c5fd-715f-8a28-f3a1317c299b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0-YMPRYBkVQRQVJMbC2TCIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_62d46cd3-e486-4d85-a97b-3fc9de9ec0ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "South Tacoma",
      "poi_type": "Transportation & Transit",
      "poi_address": "5650 S Washington St, Tacoma, WA 98409, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-9848-7079-a50a-f131c39bd350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08aa-9848-7079-a50a-f131c39bd350",
        "storage_key": "property/6767906449166879/019d08aa-9848-7079-a50a-f131c39bd350.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.soundtransit.org/rider-guide/south-tacoma-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=12668939942539777770&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "south-tacoma",
      "poi_latitude": "47.20385410000001",
      "poi_longitude": "-122.4855229",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 888-889-6368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-c5fd-715f-8a28-f3a1317c299b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-c5fd-715f-8a28-f3a1317c299b",
        "storage_key": "property/6767906449166879/019d08aa-c5fd-715f-8a28-f3a1317c299b.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJwWoE8xIAkVQR6lbXO8Ed0a8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_9b4974d9-78c6-452a-9502-873b3a2a9c06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Lakewood City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6000 Main St SW, Lakewood, WA 98499, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-4288-7138-80bf-6c58bc11ef75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-4288-7138-80bf-6c58bc11ef75",
        "storage_key": "property/6767906449166879/019d08ab-4288-7138-80bf-6c58bc11ef75.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://cityoflakewood.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13735021253969182974&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lakewood-city-hall",
      "poi_latitude": "47.1614011",
      "poi_longitude": "-122.5160169",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 253-589-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-c63a-7716-922c-0b080d8bed00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-c63a-7716-922c-0b080d8bed00",
        "storage_key": "property/6767906449166879/019d08aa-c63a-7716-922c-0b080d8bed00.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCxM6XyABkVQR_gBGKQ-ZnL4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_5056decc-7e00-43c4-bb62-24bd4117d06b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Barnes Gate",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Barnes Blvd, Tacoma, WA 98438, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8708195169912361513&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "barnes-gate",
      "poi_latitude": "47.1168126",
      "poi_longitude": "-122.4940242",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b22d-7158-a776-be2cd6a97445",
        "storage_key": "property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJde8cjwgEkVQRKRJmeV652Xg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_979d6702-25af-44a7-b0e2-0013069fc4ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "Superior Tank Lines",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1112 Center St, Tacoma, WA 98409, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-434b-7058-9d6a-a0e879488466.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-434b-7058-9d6a-a0e879488466",
        "storage_key": "property/6767906449166879/019d08ab-434b-7058-9d6a-a0e879488466.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://superiortanklines.com/careers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14826495922307135905&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "superior-tank-lines",
      "poi_latitude": "47.2333958",
      "poi_longitude": "-122.4489631",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 909-430-0855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b22d-7158-a776-be2cd6a97445",
        "storage_key": "property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbqKMmdVkFQRofnkuHxLws0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_846c533d-dd7e-4f7d-8380-437c78ff50fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "LAKEWOOD BUSINESS PARK",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10029 S Tacoma Way, Tacoma, WA 98499, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08ab-44a7-769d-a855-7934d26e16c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-44a7-769d-a855-7934d26e16c9",
        "storage_key": "property/6767906449166879/019d08ab-44a7-769d-a855-7934d26e16c9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18017921063620266733&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lakewood-business-park",
      "poi_latitude": "47.1659395",
      "poi_longitude": "-122.4780515",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b22d-7158-a776-be2cd6a97445",
        "storage_key": "property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs1wFjwcBkVQR7UodjL6DDPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f01f3a16-bead-4a91-8f96-1c077e0af3da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "custom",
      "poi_name": "BLDG 15-ID OFFICE CAMP MURRAY",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15 building, Camp Murray, WA 98430, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://mil.wa.gov/deers-id-card-office",
      "poi_directions_map_url": "https://maps.google.com/?cid=9013848642153849145&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bldg-15-id-office-camp-murray",
      "poi_latitude": "47.1168342",
      "poi_longitude": "-122.5623986",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 13 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 253-512-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08aa-b22d-7158-a776-be2cd6a97445",
        "storage_key": "property/6767906449166879/019d08aa-b22d-7158-a776-be2cd6a97445.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ34Mmh2sHkVQROaG3JpWfF30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_70b5a7fa-0236-443e-a470-187a51586465",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_391915da-db0f-47a0-bac6-464de975db83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_c3da2d6f-39f7-4b45-a15b-c0aaf7e96a59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_bd0d01db-497f-423f-8802-775e0d898064",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_8ad1db14-d526-4cda-9bdc-eb56d00907d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_370ecbf5-8a37-43a6-819c-42794d7c7cfd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_b84742ef-9596-4dbf-a413-b4a50e1d8bbb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_0e851039-9f97-4828-82dc-915de9632ba4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "rating": "5.0",
      "name": "Nancy HUMPHREYS",
      "text": "Though having just relocated from California I am thoroughly impressed and would highly recommend Chambers Creek Estates.  There are so many amenities and it is located in a beautiful area close to essential services.  This place is like a resort, with beautifully maintained grounds, and it is a very safe community.  The management staff give high priority to residents' concerns and are highly professional.  Excellent place to live and very affordable, too.",
      "date": "2025-05-15",
      "title": ""
    },
    {
      "id": "custom_d7e831e4-e6dd-40f7-b6f2-b5a1711d1fce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "rating": "5.0",
      "name": "Marie F. Bourdeau Clement",
      "text": "I have no complaints about my experience with Chambers Creek Estates. The location is not only beautiful but also very clean and well-organized. Thank you for everything you do in this neighborhood and the community as well. Be blessed!",
      "date": "2025-05-25",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_97a1f9cb0d9188cc51237f9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019ddcf4-436b-742e-923a-5ac8de15aaff.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf4-436b-742e-923a-5ac8de15aaff",
        "storage_key": "property/6767906449166879/019ddcf4-436b-742e-923a-5ac8de15aaff.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1 Bed 1 Bath",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5Xn4PD4yV6Y"
    },
    {
      "id": "ec_70545de656e267dfde43f0b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019ddcf4-4386-733e-a2a6-ef7740590792.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf4-4386-733e-a2a6-ef7740590792",
        "storage_key": "property/6767906449166879/019ddcf4-4386-733e-a2a6-ef7740590792.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2 Bed 2 Bath",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=AivYWNLuEnK"
    },
    {
      "id": "ec_42a7101c12ae946bb6233f94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019ddcf4-437f-747e-a33b-cf3e86d8a1fb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcf4-437f-747e-a33b-cf3e86d8a1fb",
        "storage_key": "property/6767906449166879/019ddcf4-437f-747e-a33b-cf3e86d8a1fb.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3 Bed 2 Bath",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oAww3rLZaLK"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a9d2a-f959-77b8-8a28-f73c1c61fcf3",
      "lead_source": "LANDING_PAGE",
      "name": "ctl-chambers-creek-estates",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "indoor-swimming-pool-apartments-university-place-wa",
      "search_query": "indoor swimming pool apartments University Place WA",
      "category": "Amenity",
      "h1_title": "Indoor Pool Apartments in University Place",
      "h2_subtitle": "Looking for an apartment with an indoor swimming pool? Discover Chambers Creek Estates in University Place, WA, for resort-style living!",
      "page_copy": "At Chambers Creek Estates, indulge in the luxury of having an indoor swimming pool right within your community. Located in University Place, WA, our apartments offer a unique blend of comfort and convenience. Choose from a variety of layouts, including cozy studios or more spacious three-bedroom options, perfect for any lifestyle. \n\nRelax after a long day by taking a leisurely swim in the inviting indoor pool or engage with friends at our clubhouse which offers complimentary Wi-Fi. Our vibrant resident activity program ensures there's always something exciting happening. Located conveniently in University Place, you'll experience the best of both serene living and vibrant community amenities. Whether you're seeking flexible lease terms or simply a place that feels like home, Chambers Creek Estates has it all.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Indoor Pool Apartments in University Place, WA",
      "seo_description": "Explore indoor swimming pool apartments in University Place, WA at Chambers Creek Estates. Enjoy spacious living and vibrant amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "basketball-court-apartment-rentals-pierce-county",
      "search_query": "basketball court apartment rentals Pierce County",
      "category": "Amenity",
      "h1_title": "Basketball Court Apartments in Pierce County",
      "h2_subtitle": "Discover apartment rentals with basketball courts in Pierce County. Chambers Creek Estates offers active living in University Place, WA.",
      "page_copy": "For those seeking an active lifestyle, Chambers Creek Estates offers the perfect apartment rentals in Pierce County, complete with outdoor basketball courts. Set in University Place, WA, our community not only prioritizes spacious and comfortable living but also caters to residents who enjoy staying active outside. From cozy studios to expansive three-bedroom layouts, there's a home for everyone here.\n\nBeyond the basketball court, our community features a resident activity program, keeping the spirit lively and engaging. The inviting clubhouse with complimentary Wi-Fi offers a space to unwind or connect with neighbors, and our indoor swimming pool provides a perfect way to relax. With flexible lease terms and the ease of online rent payments, living at Chambers Creek Estates is both stress-free and enjoyable. Explore vibrant living today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Basketball Court Apartments in Pierce County",
      "seo_description": "Discover basketball court apartment rentals in Pierce County at Chambers Creek Estates. Enjoy active living with vibrant community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "flexible-lease-term-apartments-university-place",
      "search_query": "flexible lease term apartments University Place",
      "category": "Amenity",
      "h1_title": "Flexible Lease Apartments in University Place",
      "h2_subtitle": "Looking for flexible lease term apartments? Chambers Creek Estates in University Place offers customizable living arrangements just for you.",
      "page_copy": "At Chambers Creek Estates, we understand the need for adaptable living arrangements. Located in the heart of University Place, our apartments offer flexible lease terms that cater to your unique lifestyle. Whether you're seeking a temporary residence or planning a longer stay, our community provides the perfect solution with a range of living options, from intimate studios to spacious three-bedroom layouts.\n\nBeyond adaptable leasing, we deliver exceptional amenities, including an indoor swimming pool, a clubhouse with complimentary Wi-Fi, and fun resident activities. Our basketball courts offer an opportunity to stay active, while online rent payments add convenience to your life. Experience the comfort and flexibility of making Chambers Creek Estates your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Flexible Lease Apartments in University Place",
      "seo_description": "Explore flexible lease term apartments at Chambers Creek Estates in University Place, WA, where comfort meets convenience with adaptable living options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "spacious-apartments-clubhouse-near-98467",
      "search_query": "spacious apartments with clubhouse near 98467",
      "category": "Amenity",
      "h1_title": "Spacious Apartments Near 98467",
      "h2_subtitle": "Find spacious apartments with a clubhouse near 98467 at Chambers Creek Estates. Enjoy a vibrant community in University Place, WA.",
      "page_copy": "Discover the perfect blend of space and community at Chambers Creek Estates in University Place, located conveniently near the 98467 area. Our spacious apartments range from studios to three-bedroom layouts, catering to diverse living preferences. Beyond roomy interiors, our community boasts a welcoming clubhouse, offering complimentary Wi-Fi for work or leisure activities.\n\nOur amenities go beyond just spacious living. Residents can enjoy an indoor swimming pool and participate in various events through our resident activity program. The outdoor basketball courts offer a place to stay active and make new friends. With comfortable accommodations and a vibrant community atmosphere, Chambers Creek Estates is the ideal place to call home near 98467.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Apartments with Clubhouse Near 98467",
      "seo_description": "Explore spacious apartments with a clubhouse near 98467 at Chambers Creek Estates. Enjoy expansive living and vibrant amenities in University Place, WA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-university-place-wa",
      "search_query": "smoke free apartments University Place WA",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments in University Place",
      "h2_subtitle": "Explore smoke-free apartments in University Place, WA at Chambers Creek Estates. Experience healthy, comfortable living spaces today.",
      "page_copy": "Chambers Creek Estates offers a refreshingly clean living environment with our smoke-free apartments located in University Place, WA. Our community prioritizes your well-being, ensuring a healthy and fresh atmosphere for all residents. Choose from a variety of modern layouts, including studios and three-bedroom floor plans, each designed to provide comfort and convenience.\n\nLiving at Chambers Creek Estates means you’re surrounded by exceptional amenities. Enjoy our indoor swimming pool, which provides a serene escape year-round. The clubhouse with complimentary Wi-Fi and outdoor basketball courts adds value and vibrancy to our community. With flexible lease terms and amenities designed to enhance life, make the choice for a smoke-free living environment today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments in University Place, WA",
      "seo_description": "Discover smoke-free apartments at Chambers Creek Estates in University Place, WA. Enjoy a fresh living environment with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "studio-apartments-university-place-wa",
      "search_query": "studio apartments university place wa",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in University Place, WA",
      "h2_subtitle": "Explore modern studio apartments in University Place, WA at Chambers Creek Estates. Perfect for cozy, convenient living.",
      "page_copy": "Embrace cozy living at Chambers Creek Estates with our charming studio apartments in University Place, WA. Ideal for individuals seeking a convenient and comfortable home, each studio space has been thoughtfully designed to maximize functionality and comfort. Enjoy the tranquility of a peaceful community while being close to local conveniences and vibrant city life.\n\nOur residents have access to outstanding amenities like our indoor swimming pool, keeping you relaxed throughout the seasons. The community clubhouse offers complimentary Wi-Fi, making it perfect for social gatherings or getting some work done. With flexible lease terms and a smoke-free environment, our studio apartments provide everything you need for a comfortable, modern lifestyle in University Place, WA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in University Place, WA",
      "seo_description": "Find studio apartments at Chambers Creek Estates in University Place, WA. Experience cozy, convenient living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-pierce-county",
      "search_query": "1 bedroom apartments pierce county",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Pierce County",
      "h2_subtitle": "Discover spacious 1 bedroom apartments in Pierce County at Chambers Creek Estates. Perfect for singles or couples seeking comfort and style.",
      "page_copy": "Welcome to Chambers Creek Estates, where you'll find comfortable 1 bedroom apartments nestled in Pierce County. Perfectly suited for those who desire a harmonious blend of privacy and community, our one-bedroom options offer spacious layouts designed to meet all of your living needs. Experience peaceful living while being close to the amenities University Place has to offer.\n\nResidents enjoy an array of community features, including a refreshing indoor swimming pool and a clubhouse complete with complimentary Wi-Fi. Additionally, partake in our resident activity program to connect with neighbors and make new friends. With flexible lease terms, a smoke-free environment, and a convenient location, our 1 bedroom apartments provide an ideal home base in Pierce County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Pierce County",
      "seo_description": "Explore 1 bedroom apartments at Chambers Creek Estates in Pierce County. Experience comfort and community with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "2-bedroom-rentals-near-98467",
      "search_query": "2 bedroom rentals near 98467",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Rentals Near 98467",
      "h2_subtitle": "Find your ideal 2 bedroom rental near 98467 at Chambers Creek Estates. Enjoy spacious living with unmatched amenities.",
      "page_copy": "At Chambers Creek Estates, discover spacious 2 bedroom rentals conveniently located near the 98467 area. Each apartment provides an inviting atmosphere, perfect for those who need extra space or enjoy hosting guests. Experience the blend of comfortable living and vibrant amenities that cater to your lifestyle needs.\n\nOur community offers a plethora of features including an indoor swimming pool and a well-equipped clubhouse with complimentary Wi-Fi. Participate in our resident activity program to stay engaged and make connections with your neighbors. With our smoke-free environment and flexible lease terms, Chambers Creek Estates is the perfect choice for those seeking 2 bedroom rentals near 98467 in University Place, WA.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Rentals Near 98467",
      "seo_description": "Discover 2 bedroom rentals at Chambers Creek Estates near 98467. Enjoy spacious living with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-in-university-place",
      "search_query": "3 bedroom apartments in university place",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in University Place",
      "h2_subtitle": "Explore spacious 3 bedroom apartments in University Place at Chambers Creek Estates. Ideal for families or roommates seeking comfort and convenience.",
      "page_copy": "Chambers Creek Estates offers expansive 3 bedroom apartments in University Place, providing ample space for families or roommates. These thoughtfully designed apartments ensure that each room offers comfort and privacy, alongside shared areas perfect for gatherings and relaxation. Experience the perfect home environment in a vibrant community.\n\nTake advantage of our outstanding amenities, including an indoor swimming pool and a clubhouse equipped with complimentary Wi-Fi, perfect for working from home or leisure. Our resident activity program encourages community interaction, creating a welcoming neighborhood atmosphere. With flexible lease terms and a smoke-free setting, our 3 bedroom apartments cater to diverse lifestyle needs, making them an excellent choice in University Place.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in University Place",
      "seo_description": "Find spacious 3 bedroom apartments at Chambers Creek Estates in University Place. Perfect for families with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "apartments-near-university-place-primary-school",
      "search_query": "apartments near University Place Primary School",
      "category": "School",
      "h1_title": "Apartments Near University Place Primary School",
      "h2_subtitle": "Discover convenient living at Chambers Creek Estates, located near University Place Primary School. Perfect for families seeking balance and accessibility.",
      "page_copy": "Situated in University Place, Chambers Creek Estates offers ideal apartments near University Place Primary School, ensuring a short commute for families. Our variety of floor plans, from studios to three-bedroom units, cater to diverse family sizes and lifestyles, all within reach of excellent educational institutions.\n\nOur community boasts an indoor swimming pool, a clubhouse with complimentary Wi-Fi, and numerous resident activities, providing both relaxation and recreation options. With flexible lease terms, Chambers Creek Estates offers a family-friendly living environment, making it the perfect choice near University Place Primary School. Experience the comfort and convenience of having your child's school just a short distance away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University Place Primary School",
      "seo_description": "Find family-friendly apartments at Chambers Creek Estates near University Place Primary School. Enjoy comfort and convenience with excellent amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "chambers-creek-estates-near-chambers-primary-school",
      "search_query": "Chambers Creek Estates close to Chambers Primary School",
      "category": "School",
      "h1_title": "Chambers Creek Estates Near Chambers Primary",
      "h2_subtitle": "Live at Chambers Creek Estates, conveniently close to Chambers Primary School. Enjoy family-friendly living in our vibrant community.",
      "page_copy": "Chambers Creek Estates is strategically located close to Chambers Primary School, making it an ideal residence for families prioritizing education and convenience. Our apartments, ranging from studios to three-bedroom layouts, are designed to accommodate various lifestyle needs while being a short drive from the school.\n\nThe community features an indoor swimming pool, a clubhouse with free Wi-Fi, and a fun-filled resident activity program, offering both children and adults endless possibilities for leisure. Flexible lease terms make it easy to find your perfect home at Chambers Creek Estates, where educational facilities and vibrant living combine seamlessly near Chambers Primary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chambers Creek Estates Near Chambers Primary",
      "seo_description": "Chambers Creek Estates offers family-friendly living near Chambers Primary School with great amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "evergreen-primary-school-proximity-apartments",
      "search_query": "Evergreen Primary School proximity apartments",
      "category": "School",
      "h1_title": "Apartments Near Evergreen Primary School",
      "h2_subtitle": "Find ideal apartments with proximity to Evergreen Primary School at Chambers Creek Estates. Perfect for families seeking nearby educational options.",
      "page_copy": "Chambers Creek Estates provides exceptional apartments with proximity to Evergreen Primary School, offering an unbeatable option for families who value educational convenience. Our diverse floor plans, ranging from studios to spacious three-bedroom options, fit various household needs while placing you close to the school.\n\nEmbrace a community filled with amenities such as an indoor swimming pool and a clubhouse equipped with complimentary Wi-Fi. With activities designed to engage residents of all ages, our apartments offer a welcoming and dynamic environment. Flexible lease terms make settling into this prime location easier, providing seamless access to Evergreen Primary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Evergreen Primary School",
      "seo_description": "Chambers Creek Estates offers nearby apartment options with great amenities for families near Evergreen Primary School.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "sunset-primary-school-neighborhood-rentals",
      "search_query": "Sunset Primary School neighborhood rentals",
      "category": "School",
      "h1_title": "Rentals Near Sunset Primary School",
      "h2_subtitle": "Explore neighborhood rentals near Sunset Primary School at Chambers Creek Estates. Ideal for families prioritizing education and community.",
      "page_copy": "Discover the ideal neighborhood rentals near Sunset Primary School at Chambers Creek Estates, perfect for families emphasizing convenience and community living. Our property offers a variety of floor plans, accommodating both small and large families, all within close proximity to quality education.\n\nChambers Creek Estates includes robust amenities like an indoor swimming pool and a resident activity program, making it a vibrant place for families. Flexible lease terms provide ease of living, ensuring you find the perfect fit for your family's needs in a neighborhood that balances community and education access near Sunset Primary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Sunset Primary School",
      "seo_description": "Chambers Creek Estates offers family-friendly rentals with top amenities near Sunset Primary School, perfectly balancing education and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "apartments-nearby-drum-intermediate-school",
      "search_query": "apartments nearby Drum Intermediate School",
      "category": "School",
      "h1_title": "Apartments Near Drum Intermediate School",
      "h2_subtitle": "Discover apartments nearby Drum Intermediate School at Chambers Creek Estates. Perfect for families seeking educational convenience.",
      "page_copy": "Located conveniently close to Drum Intermediate School, Chambers Creek Estates offers fantastic apartments that provide both comfort and accessibility for families. Whether you're interested in a cozy studio or a spacious three-bedroom unit, you'll find a perfect fit within our community, all within a convenient distance to the school.\n\nOur complex is equipped with family-friendly amenities like an indoor pool and a clubhouse with complimentary Wi-Fi, ensuring plenty of opportunities for relaxation and socialization. Flexible lease terms make it easy for families to settle in and enjoy seamless access to Drum Intermediate School, combining exceptional apartment living with educational convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Drum Intermediate School",
      "seo_description": "Live at Chambers Creek Estates for convenient apartment options near Drum Intermediate School, featuring great amenities and proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "apartments-near-narrows-view-intermediate-school-wa",
      "search_query": "apartments near Narrows View Intermediate School WA",
      "category": "School",
      "h1_title": "Apartments Near Narrows View School WA",
      "h2_subtitle": "Discover prime apartments near Narrows View Intermediate School WA at Chambers Creek Estates. Perfect for families prioritizing education and convenience.",
      "page_copy": "Chambers Creek Estates, located in University Place, WA, offers ideal apartments near Narrows View Intermediate School WA. Our spacious studios, one, two, and three-bedroom layouts provide the perfect living space for families looking to stay close to quality education. Enjoy the benefit of a short commute combined with modern amenities.\n\nExperience a community filled with exciting features such as a refreshing indoor swimming pool and an activity-enriched resident program. The clubhouse with complimentary Wi-Fi provides both entertainment and productivity opportunities. With flexible lease terms, finding your family's next home near Narrows View Intermediate School has never been easier or more convenient.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Narrows View School WA",
      "seo_description": "Find ideal apartments near Narrows View Intermediate School WA at Chambers Creek Estates, featuring convenient access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "rentals-by-curtis-junior-high-school-98467",
      "search_query": "rentals by Curtis Junior High School 98467",
      "category": "School",
      "h1_title": "Rentals by Curtis Junior High School",
      "h2_subtitle": "Explore rentals by Curtis Junior High School in the 98467 area at Chambers Creek Estates. Enjoy proximity and modern amenities.",
      "page_copy": "Find perfect rentals by Curtis Junior High School in the 98467 area at Chambers Creek Estates. Our community offers a variety of floor plans from studios to three-bedroom apartments, ideal for families desiring convenient access to quality education and community living.\n\nResidents enjoy premier amenities including an inviting indoor swimming pool and a fully equipped clubhouse with Wi-Fi. With flexible lease terms, settling in and enjoying seamless access to Curtis Junior High School is easy and straightforward. Experience the comfort and convenience at Chambers Creek Estates, where vibrant living meets educational excellence.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Curtis Junior High School",
      "seo_description": "Discover family-friendly rentals by Curtis Junior High School in the 98467 area at Chambers Creek Estates, offering prime amenities and close proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "chambers-creek-estates-near-curtis-senior-high-school",
      "search_query": "Chambers Creek Estates near Curtis Senior High School",
      "category": "School",
      "h1_title": "Chambers Creek Estates by Curtis High",
      "h2_subtitle": "Discover Chambers Creek Estates near Curtis Senior High School. Experience convenience and comfort with exceptional amenities.",
      "page_copy": "Chambers Creek Estates offers unparalleled living near Curtis Senior High School—an ideal choice for families looking for both comfort and convenience. Select from our wide range of floor plans, including cozy studios and expansive three-bedroom apartments, all situated close to this prominent educational establishment in University Place, WA.\n\nEnjoy our community's vibrant amenities, such as the indoor swimming pool and engaging resident activity program. The clubhouse with complimentary Wi-Fi creates a welcoming environment perfect for study sessions and unwinding. Experience the ease of online rent payments and flexible lease terms, making life simpler while granting students perfect proximity to Curtis Senior High School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Chambers Creek Estates by Curtis High",
      "seo_description": "Live at Chambers Creek Estates for ideal proximity to Curtis Senior High School with exceptional amenities and flexible leasing options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "apartments-close-to-charles-wright-academy-pierce-county",
      "search_query": "apartments close to Charles Wright Academy Pierce County",
      "category": "School",
      "h1_title": "Apartments Near Charles Wright Academy",
      "h2_subtitle": "Discover comfortable apartments close to Charles Wright Academy in Pierce County. Experience convenience at Chambers Creek Estates.",
      "page_copy": "Chambers Creek Estates provides fantastic living options in Pierce County, ideal for those seeking apartments close to Charles Wright Academy. With a selection of studios, one, two, and three-bedroom layouts, our community caters to diverse needs, ensuring comfort and convenience for families focused on education.\n\nResidents can take advantage of top-notch amenities, including an indoor swimming pool perfect for relaxation and a clubhouse with complimentary Wi-Fi, ideal for both leisure and learning. Flexible lease terms and easy online rent payments enhance the living experience. Choose Chambers Creek Estates for its proximity to Charles Wright Academy and vibrant community living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Charles Wright Academy",
      "seo_description": "Find comfortable apartments close to Charles Wright Academy in Pierce County at Chambers Creek Estates, featuring modern amenities and flexible leases.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "university-puget-sound-nearby-university-place-apartments",
      "search_query": "University of Puget Sound nearby University Place apartments",
      "category": "School",
      "h1_title": "Apartments by University of Puget Sound",
      "h2_subtitle": "Find University Place apartments near University of Puget Sound. Discover modern living with unbeatable amenities.",
      "page_copy": "Explore University Place apartments near the University of Puget Sound at Chambers Creek Estates. Our community offers a variety of floor plans, from cozy studios to expansive three-bedrooms, providing the ideal living situation for students and professionals seeking convenience and luxury.\n\nResidents enjoy a wealth of amenities, including an indoor swimming pool and a clubhouse with complimentary Wi-Fi, perfect for relaxing and socializing. Our flexible lease terms cater to diverse needs, while our location offers easy access to both the University of Puget Sound and the vibrant attractions of University Place. Experience the perfect blend of proximity and modern living at Chambers Creek Estates.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by University of Puget Sound",
      "seo_description": "Discover University Place apartments by the University of Puget Sound at Chambers Creek Estates, offering top amenities and flexible leases.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "apartments-near-multicare-tacoma-general-hospital-university-place",
      "search_query": "apartments near MultiCare Tacoma General Hospital University Place",
      "category": "Hospital",
      "h1_title": "Apartments Near MultiCare Tacoma General",
      "h2_subtitle": "Discover University Place apartments close to MultiCare Tacoma General Hospital. Enjoy modern amenities and convenient living.",
      "page_copy": "Chambers Creek Estates offers ideal apartments near MultiCare Tacoma General Hospital in University Place. Our diverse floor plans range from cozy studios to spacious three-bedroom apartments, providing a perfect fit for healthcare professionals and their families seeking proximity and comfort.\n\nEnjoy community amenities such as an indoor swimming pool and a vibrant clubhouse with complimentary Wi-Fi, offering leisure and connectivity right at your doorstep. With flexible lease terms and online rent payments, living here means convenience. Choose Chambers Creek Estates for easy access to MultiCare Tacoma General Hospital and a balanced lifestyle in University Place.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near MultiCare Tacoma General",
      "seo_description": "Find convenient University Place apartments near MultiCare Tacoma General Hospital at Chambers Creek Estates, offering top amenities and flexible leases.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "apartments-close-to-st-joseph-medical-center-pierce-county",
      "search_query": "apartments close to St. Joseph Medical Center Pierce County",
      "category": "Hospital",
      "h1_title": "Apartments Near St. Joseph Medical Center",
      "h2_subtitle": "Explore apartments close to St. Joseph Medical Center in Pierce County. Enjoy excellent amenities at Chambers Creek Estates.",
      "page_copy": "Chambers Creek Estates presents convenient living options with apartments close to St. Joseph Medical Center in Pierce County. Whether you're a healthcare professional or a family seeking proximity to one of the area's premier medical facilities, our community provides a variety of floor plans from studios to three-bedroom layouts tailored to diverse resident needs.\n\nExperience a range of amenities, including a relaxing indoor swimming pool and a lively clubhouse with complimentary Wi-Fi, offering both comfort and convenience. Our flexible lease terms and online rent payment system cater to modern living. Choose Chambers Creek Estates for easy access to St. Joseph Medical Center and enjoy a thriving community atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Joseph Medical Center",
      "seo_description": "Discover apartments close to St. Joseph Medical Center in Pierce County at Chambers Creek Estates, featuring modern amenities and flexible leases.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "apartments-near-chambers-creek-regional-park-university-place",
      "search_query": "apartments near chambers creek regional park university place",
      "category": "Park",
      "h1_title": "Apartments by Chambers Creek Regional Park",
      "h2_subtitle": "Live near Chambers Creek Regional Park in University Place. Our apartments offer great amenities and easy park access.",
      "page_copy": "Experience the perfect blend of nature and comfort at Chambers Creek Estates. Our apartments are conveniently located near Chambers Creek Regional Park in University Place, offering residents the opportunity to enjoy the great outdoors just steps away from home. Whether you choose a studio or a spacious three-bedroom, you'll find a welcoming community and a variety of amenities.\n\nResidents enjoy an indoor swimming pool, a clubhouse with free Wi-Fi, and a resident activity program designed to enrich your living experience. With flexible lease terms and online rent payments, managing your home life is easy. Relish in the beauty of Chambers Creek Regional Park while enjoying the modern comforts of apartment living at Chambers Creek Estates.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Chambers Creek Regional Park",
      "seo_description": "Find apartments near Chambers Creek Regional Park in University Place. Enjoy park access and great amenities at Chambers Creek Estates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "rentals-close-to-curran-apple-orchard-park-wa",
      "search_query": "rentals close to curran apple orchard park wa",
      "category": "Park",
      "h1_title": "Rentals Near Curran Apple Orchard Park",
      "h2_subtitle": "Discover rentals close to Curran Apple Orchard Park, WA. Enjoy park-side living and modern amenities at Chambers Creek Estates.",
      "page_copy": "Find your next home at Chambers Creek Estates, offering rentals close to the charming Curran Apple Orchard Park in WA. Perfectly situated for those who love nature, our community provides easy access to one of University Place's most beloved outdoor destinations. Select from a variety of floor plans, including studios and expansive three-bedroom homes, each designed to fit your lifestyle.\n\nResidents benefit from amenities such as an indoor swimming pool and a vibrant clubhouse, providing entertainment and relaxation opportunities year-round. With flexible lease terms and the convenience of online rent payments, life at Chambers Creek Estates is hassle-free. Embrace park-side living and enjoy modern comforts by choosing our rentals near Curran Apple Orchard Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Curran Apple Orchard Park",
      "seo_description": "Explore rentals near Curran Apple Orchard Park, WA at Chambers Creek Estates. Enjoy modern amenities and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "living-by-cirque-bridgeport-park-up-98467",
      "search_query": "living by cirque bridgeport park up 98467",
      "category": "Park",
      "h1_title": "Living Near Cirque Bridgeport Park",
      "h2_subtitle": "Enjoy living by Cirque Bridgeport Park in UP's 98467 area. Discover spacious homes and great amenities at Chambers Creek Estates.",
      "page_copy": "Welcome to the best in community living at Chambers Creek Estates, located near Cirque Bridgeport Park in UP's 98467. Our apartments offer the perfect balance of comfort and convenience, making it easy to enjoy the beautiful park just moments away. Choose from a range of floor plans including cozy studios and large three-bedroom units to suit your lifestyle needs.\n\nAt Chambers Creek Estates, residents appreciate amenities like an indoor pool and a clubhouse equipped with complimentary Wi-Fi, designed for relaxation and community gatherings. Our flexible lease terms and online rent payment options provide added convenience, ensuring a seamless living experience. Enjoy the vibrant local scene and the tranquility of park-side living right here in University Place.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Cirque Bridgeport Park UP",
      "seo_description": "Explore living options near Cirque Bridgeport Park, UP 98467. Find spacious homes and modern amenities at Chambers Creek Estates.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "apartments-near-colegate-playground-pierce-county",
      "search_query": "apartments near colegate playground pierce county",
      "category": "Park",
      "h1_title": "Apartments by Colegate Playground",
      "h2_subtitle": "Discover apartments near Colegate Playground in Pierce County. Enjoy family-friendly living at Chambers Creek Estates.",
      "page_copy": "Chambers Creek Estates offers the ideal family-friendly living environment, located conveniently near Colegate Playground in Pierce County. Our community is perfect for those who enjoy an active lifestyle with easy access to outdoor recreational areas. Choose from a variety of floor plans, including studios and three-bedroom options, designed to offer comfort and convenience.\n\nEverything you need is within reach at Chambers Creek Estates. From an indoor swimming pool to a resident activity program, we provide amenities that cater to all ages. Flexible lease terms and hassle-free online rent payments make living here stress-free. Experience the combination of community living and proximity to Colegate Playground, right in the heart of Pierce County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Colegate Playground",
      "seo_description": "Find apartments near Colegate Playground, Pierce County, at Chambers Creek Estates. Enjoy family-friendly amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "rentals-by-creekside-park-university-place",
      "search_query": "rentals by creekside park university place",
      "category": "Park",
      "h1_title": "Rentals Near Creekside Park",
      "h2_subtitle": "Explore rentals by Creekside Park in University Place. Enjoy nature and community living at Chambers Creek Estates.",
      "page_copy": "Discover the serene living environment at Chambers Creek Estates, offering rentals by Creekside Park in University Place. Our community is perfect for those who appreciate nature and a close-knit community, with the park available just a short stroll away. Choose from a variety of spacious floor plans, including studios and three-bedroom layouts, designed to fit your lifestyle needs.\n\nAt Chambers Creek Estates, residents enjoy amenities like an indoor swimming pool and a modern clubhouse with complimentary Wi-Fi, enhancing both relaxation and connectivity. With convenient online rent payments and flexible lease terms, we make it easy to call our community home. Experience the best of park-side living while enjoying all that University Place has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Creekside Park, UP",
      "seo_description": "Discover rentals by Creekside Park, University Place, at Chambers Creek Estates. Enjoy community amenities and park-side living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "apartments-close-to-tacoma-nature-center-university-place",
      "search_query": "apartments close to tacoma nature center university place",
      "category": "Park",
      "h1_title": "Apartments Near Tacoma Nature Center",
      "h2_subtitle": "Find apartments close to Tacoma Nature Center in University Place. Experience nature and modern living at Chambers Creek Estates.",
      "page_copy": "Welcome to Chambers Creek Estates, offering a perfect blend of modern living and nature’s beauty, with apartments close to Tacoma Nature Center in University Place. Our community provides an excellent location for nature lovers who value being near green spaces while enjoying the comforts of city living. Choose from our selection of studio to three-bedroom apartments, each designed with spacious living in mind.\n\nResidents at Chambers Creek Estates enjoy top-notch amenities such as an indoor swimming pool and a welcoming clubhouse with free Wi-Fi access. Our flexible lease terms and seamless online rent payment system make life simpler, allowing more time to explore the nearby natural attractions. Embrace the convenience of being close to Tacoma Nature Center while enjoying all the contemporary features of our community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tacoma Nature Center",
      "seo_description": "Live near Tacoma Nature Center in University Place at Chambers Creek Estates. Enjoy modern amenities and a beautiful natural setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166879",
      "source": "generator",
      "page_item_url": "apartments-near-seattle-tacoma-airport-wa",
      "search_query": "apartments near Seattle–Tacoma International Airport WA",
      "category": "Transit",
      "h1_title": "Apartments Near Sea-Tac Airport",
      "h2_subtitle": "Discover apartments near Seattle–Tacoma International Airport, WA. Enjoy convenient living at Chambers Creek Estates.",
      "page_copy": "Chambers Creek Estates provides convenient living with apartments near Seattle–Tacoma International Airport in WA. Perfectly situated for frequent travelers or aviation enthusiasts, our community offers easy access to the airport while maintaining a peaceful residential atmosphere. Choose from a variety of layouts, including studios and expansive three-bedroom apartments, tailored to meet diverse lifestyle needs.\n\nOur community boasts an array of amenities designed with comfort in mind, such as an indoor swimming pool and clubhouse equipped with complimentary Wi-Fi. We offer flexible lease terms and a simple online rent payment system to make your life as seamless as possible. Experience the balance of serene living and travel convenience at Chambers Creek Estates, perfectly positioned near Seattle–Tacoma International Airport.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and pine trees.",
        "public_id": "019d08a9-9684-7461-b382-2c3dc3a96b3d",
        "storage_key": "property/6767906449166879/019d08a9-9684-7461-b382-2c3dc3a96b3d.webp",
        "width": 640,
        "height": 480
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sea-Tac Airport, WA",
      "seo_description": "Chambers Creek Estates offers apartments near Seattle–Tacoma Airport, WA, featuring modern amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5605"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372403889"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KM453589"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "51934474406"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-487-7803"
    }
  ],
  "custom_qb_id": "5605",
  "custom_repli_id": "18372403889",
  "custom_google_gtm_id": "GTM-KM453589",
  "custom_hubspot_company_id": "51934474406",
  "custom_ppc_tracking_phone_number": "844-487-7803"
};

export const generatedAt = '2026-10-05T20:58:25.165Z';
